/* tslint:disable */
/* eslint-disable */
/**
 * OnData.SecureFile
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AddFileTagInput
 */
export interface AddFileTagInput {
    /**
     * 
     * @type {string}
     * @memberof AddFileTagInput
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface AnalyzerDiscoveryInput
 */
export interface AnalyzerDiscoveryInput {
    /**
     * 
     * @type {string}
     * @memberof AnalyzerDiscoveryInput
     */
    'clientId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzerDiscoveryInput
     */
    'orgCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzerDiscoveryInput
     */
    'clientName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzerDiscoveryInput
     */
    'softwareId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzerDiscoveryInput
     */
    'softwareVersion'?: string | null;
    /**
     * 
     * @type {JsonWebKeySet}
     * @memberof AnalyzerDiscoveryInput
     */
    'jwks'?: JsonWebKeySet;
}
/**
 * 
 * @export
 * @interface AnalyzerDiscoveryResponseDto
 */
export interface AnalyzerDiscoveryResponseDto {
    /**
     * 
     * @type {number}
     * @memberof AnalyzerDiscoveryResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AnalyzerDiscoveryResponseDto
     */
    'sessionId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AnalyzerDiscoveryResponseDto
     */
    'sessionExpireInHours'?: number;
    /**
     * 
     * @type {string}
     * @memberof AnalyzerDiscoveryResponseDto
     */
    'dataManagerEncryptedKey'?: string | null;
    /**
     * 
     * @type {Array<AnalyzerServiceInfoDto>}
     * @memberof AnalyzerDiscoveryResponseDto
     */
    'dataAnalyzerInfoList'?: Array<AnalyzerServiceInfoDto> | null;
}
/**
 * 
 * @export
 * @interface AnalyzerServiceInfoDto
 */
export interface AnalyzerServiceInfoDto {
    /**
     * 
     * @type {string}
     * @memberof AnalyzerServiceInfoDto
     */
    'dataAnalyzerEncryptedKey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzerServiceInfoDto
     */
    'dataAnalyzerPublicKey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzerServiceInfoDto
     */
    'dataAnalyzerEndpoint'?: string | null;
}
/**
 * 
 * @export
 * @interface BaseInfoTypeResponseDto
 */
export interface BaseInfoTypeResponseDto {
    /**
     * 
     * @type {number}
     * @memberof BaseInfoTypeResponseDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseInfoTypeResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BaseInfoTypeResponseDto
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BaseInfoTypeResponseDto
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface BulkUpdateFileInput
 */
export interface BulkUpdateFileInput {
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateFileInput
     */
    'organizationId'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof BulkUpdateFileInput
     */
    'fileIds'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateFileInput
     */
    'primaryClassification'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateFileInput
     */
    'secondaryClassificationId'?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof BulkUpdateFileInput
     */
    'tags'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface CheckPermissionResponseDto
 */
export interface CheckPermissionResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof CheckPermissionResponseDto
     */
    'isSuccess'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CheckPermissionResponseDto
     */
    'message'?: string | null;
}
/**
 * 
 * @export
 * @interface ClassificationRefCount
 */
export interface ClassificationRefCount {
    /**
     * 
     * @type {number}
     * @memberof ClassificationRefCount
     */
    'secondaryClassificationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ClassificationRefCount
     */
    'count'?: number;
}
/**
 * 
 * @export
 * @interface ClassificationRuleDto
 */
export interface ClassificationRuleDto {
    /**
     * 
     * @type {number}
     * @memberof ClassificationRuleDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ClassificationRuleDto
     */
    'ruleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ClassificationRuleDto
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ClassificationRuleDto
     */
    'targetClassification'?: number;
    /**
     * 
     * @type {string}
     * @memberof ClassificationRuleDto
     */
    'ruleDisplayTree'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ClassificationRuleDto
     */
    'priority'?: number;
    /**
     * 
     * @type {string}
     * @memberof ClassificationRuleDto
     */
    'comment'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ClassificationRuleDto
     */
    'activeRule'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClassificationRuleDto
     */
    'createTime'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ClassificationRuleDto
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ClassificationRuleDto
     */
    'predecessorId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ClassificationRuleDto
     */
    'serialNumber'?: number;
    /**
     * 
     * @type {RuleRowState}
     * @memberof ClassificationRuleDto
     */
    'rowStatus'?: RuleRowState;
}
/**
 * 
 * @export
 * @interface ClassificationRuleInput
 */
export interface ClassificationRuleInput {
    /**
     * 
     * @type {number}
     * @memberof ClassificationRuleInput
     */
    'ruleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ClassificationRuleInput
     */
    'displayName': string;
    /**
     * 
     * @type {number}
     * @memberof ClassificationRuleInput
     */
    'targetClassification'?: number;
    /**
     * 
     * @type {string}
     * @memberof ClassificationRuleInput
     */
    'ruleDisplayTree': string;
    /**
     * 
     * @type {number}
     * @memberof ClassificationRuleInput
     */
    'priority'?: number;
    /**
     * 
     * @type {string}
     * @memberof ClassificationRuleInput
     */
    'comment'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ClassificationRuleInput
     */
    'activeRule'?: boolean;
}
/**
 * 
 * @export
 * @interface ClassificationRulesDisplayDto
 */
export interface ClassificationRulesDisplayDto {
    /**
     * 
     * @type {Array<ClassificationRuleDto>}
     * @memberof ClassificationRulesDisplayDto
     */
    'allRules'?: Array<ClassificationRuleDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ClassificationRulesDisplayDto
     */
    'currRuleSetDataReady'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof ClassificationRulesDisplayDto
     */
    'currRuleSetIds'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof ClassificationRulesDisplayDto
     */
    'totalFileEntryCount'?: number;
    /**
     * 
     * @type {TrialResultStatisDto}
     * @memberof ClassificationRulesDisplayDto
     */
    'trialResultStatis'?: TrialResultStatisDto;
}
/**
 * 
 * @export
 * @interface ClassificationStatisticPointDto
 */
export interface ClassificationStatisticPointDto {
    /**
     * 
     * @type {PrimaryClassification}
     * @memberof ClassificationStatisticPointDto
     */
    'primaryClassification'?: PrimaryClassification;
    /**
     * 
     * @type {number}
     * @memberof ClassificationStatisticPointDto
     */
    'secondaryClassificationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ClassificationStatisticPointDto
     */
    'count'?: number;
}
/**
 * 
 * @export
 * @interface ClientSettingDto
 */
export interface ClientSettingDto {
    /**
     * 
     * @type {number}
     * @memberof ClientSettingDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ClientSettingDto
     */
    'clientId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ClientSettingDto
     */
    'autoDiscoveryEnabled'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientSettingDto
     */
    'scanRootFolders'?: Array<string> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum CloudProvider {
    Azure = 1,
    AzureUSGovernment = 2,
    Aws = 3,
    Gcp = 4
}

/**
 * 
 * @export
 * @interface ConfirmClassificationRuleSetInput
 */
export interface ConfirmClassificationRuleSetInput {
    /**
     * 
     * @type {boolean}
     * @memberof ConfirmClassificationRuleSetInput
     */
    'applyChangeToExistingFiles'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConfirmClassificationRuleSetInput
     */
    'overwriteManualClassification'?: boolean;
}
/**
 * 
 * @export
 * @interface ContainerRegistryPullPasswordDto
 */
export interface ContainerRegistryPullPasswordDto {
    /**
     * 
     * @type {string}
     * @memberof ContainerRegistryPullPasswordDto
     */
    'password'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContainerRegistryPullPasswordDto
     */
    'loginServer'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContainerRegistryPullPasswordDto
     */
    'tokenName'?: string | null;
}
/**
 * 
 * @export
 * @interface Counts
 */
export interface Counts {
    /**
     * 
     * @type {number}
     * @memberof Counts
     */
    'summariesCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof Counts
     */
    'totalFilesCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof Counts
     */
    'protectedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof Counts
     */
    'classifiedCount'?: number;
}
/**
 * 
 * @export
 * @interface CreateOwnerMatchRuleInput
 */
export interface CreateOwnerMatchRuleInput {
    /**
     * 
     * @type {string}
     * @memberof CreateOwnerMatchRuleInput
     */
    'computer': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOwnerMatchRuleInput
     */
    'clientId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOwnerMatchRuleInput
     */
    'pathPrefix': string;
    /**
     * 
     * @type {number}
     * @memberof CreateOwnerMatchRuleInput
     */
    'dataOwnerGroupId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateOwnerMatchRuleInput
     */
    'priority': number;
}
/**
 * 
 * @export
 * @interface CustomKeyVaultDto
 */
export interface CustomKeyVaultDto {
    /**
     * 
     * @type {number}
     * @memberof CustomKeyVaultDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CustomKeyVaultDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {CloudProvider}
     * @memberof CustomKeyVaultDto
     */
    'cloudProvider'?: CloudProvider;
    /**
     * 
     * @type {string}
     * @memberof CustomKeyVaultDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomKeyVaultDto
     */
    'clientId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomKeyVaultDto
     */
    'clientSecret'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomKeyVaultDto
     */
    'uri'?: string | null;
    /**
     * 
     * @type {CustomKeyVaultStatus}
     * @memberof CustomKeyVaultDto
     */
    'status'?: CustomKeyVaultStatus;
    /**
     * 
     * @type {string}
     * @memberof CustomKeyVaultDto
     */
    'message'?: string | null;
}
/**
 * 
 * @export
 * @interface CustomKeyVaultInput
 */
export interface CustomKeyVaultInput {
    /**
     * 
     * @type {CloudProvider}
     * @memberof CustomKeyVaultInput
     */
    'cloudProvider'?: CloudProvider;
    /**
     * 
     * @type {string}
     * @memberof CustomKeyVaultInput
     */
    'tenantId': string;
    /**
     * 
     * @type {string}
     * @memberof CustomKeyVaultInput
     */
    'clientId': string;
    /**
     * 
     * @type {string}
     * @memberof CustomKeyVaultInput
     */
    'clientSecret'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomKeyVaultInput
     */
    'uri': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum CustomKeyVaultStatus {
    Init = 0,
    InProgress = 1,
    Success = 2,
    Failed = 3
}

/**
 * 
 * @export
 * @interface DataAnalyzerSettingDto
 */
export interface DataAnalyzerSettingDto {
    /**
     * 
     * @type {number}
     * @memberof DataAnalyzerSettingDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DataAnalyzerSettingDto
     */
    'autoDiscoveryEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DataAnalyzerSettingDto
     */
    'dataAnalyzerEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DataAnalyzerSettingDto
     */
    'scanIntervalMinutes'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof DataAnalyzerSettingDto
     */
    'scanRootFolders'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DataAnalyzerSettingDto
     */
    'scanRootFoldersUnix'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface DataManagerConfigDto
 */
export interface DataManagerConfigDto {
    /**
     * 
     * @type {boolean}
     * @memberof DataManagerConfigDto
     */
    'autoDiscoveryEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DataManagerConfigDto
     */
    'dataAnalyzerEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DataManagerConfigDto
     */
    'scanIntervalHours'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DataManagerConfigDto
     */
    'scanRootFolders'?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof DataManagerConfigDto
     */
    'rescanId'?: number;
}
/**
 * 
 * @export
 * @interface DataManagerRescanPayload
 */
export interface DataManagerRescanPayload {
    /**
     * 
     * @type {number}
     * @memberof DataManagerRescanPayload
     */
    'version'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof DataManagerRescanPayload
     */
    'folders'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface DataOwnerGroupByFileId
 */
export interface DataOwnerGroupByFileId {
    /**
     * 
     * @type {number}
     * @memberof DataOwnerGroupByFileId
     */
    'ownerGroupId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataOwnerGroupByFileId
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DataOwnerGroupByFileId
     */
    'fileId'?: number;
}
/**
 * 
 * @export
 * @interface DataPoint
 */
export interface DataPoint {
    /**
     * 
     * @type {number}
     * @memberof DataPoint
     */
    'classification'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataPoint
     */
    'prevailedCRuleId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataPoint
     */
    'count'?: number;
}
/**
 * 
 * @export
 * @interface DateTimeDateTimeTuple
 */
export interface DateTimeDateTimeTuple {
    /**
     * 
     * @type {string}
     * @memberof DateTimeDateTimeTuple
     */
    'item1'?: string;
    /**
     * 
     * @type {string}
     * @memberof DateTimeDateTimeTuple
     */
    'item2'?: string;
}
/**
 * 
 * @export
 * @interface DeleteFileInstanceInput
 */
export interface DeleteFileInstanceInput {
    /**
     * 
     * @type {string}
     * @memberof DeleteFileInstanceInput
     */
    'absolutePath': string;
    /**
     * 
     * @type {string}
     * @memberof DeleteFileInstanceInput
     */
    'machine': string;
}
/**
 * 
 * @export
 * @interface DetectPattern
 */
export interface DetectPattern {
    /**
     * 
     * @type {string}
     * @memberof DetectPattern
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DetectPattern
     */
    'score'?: number;
    /**
     * 
     * @type {string}
     * @memberof DetectPattern
     */
    'regex'?: string | null;
}
/**
 * 
 * @export
 * @interface DmScanReportSummaryDto
 */
export interface DmScanReportSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof DmScanReportSummaryDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DmScanReportSummaryDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DmScanReportSummaryDto
     */
    'clientId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DmScanReportSummaryDto
     */
    'startTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DmScanReportSummaryDto
     */
    'endTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof DmScanReportSummaryDto
     */
    'startEntryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DmScanReportSummaryDto
     */
    'entryCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof DmScanReportSummaryDto
     */
    'classificationStatis'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DmScanReportSummaryDto
     */
    'duration'?: number | null;
    /**
     * 
     * @type {ReportSummaryKind}
     * @memberof DmScanReportSummaryDto
     */
    'kind'?: ReportSummaryKind;
    /**
     * 
     * @type {SummaryClassificationStatisBag}
     * @memberof DmScanReportSummaryDto
     */
    'classificationStatisBag'?: SummaryClassificationStatisBag;
}
/**
 * 
 * @export
 * @interface DmScanReportSummaryDtoPaginationResult
 */
export interface DmScanReportSummaryDtoPaginationResult {
    /**
     * 
     * @type {Array<DmScanReportSummaryDto>}
     * @memberof DmScanReportSummaryDtoPaginationResult
     */
    'items'?: Array<DmScanReportSummaryDto> | null;
    /**
     * 
     * @type {number}
     * @memberof DmScanReportSummaryDtoPaginationResult
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface DmScanReportSummaryStatisDto
 */
export interface DmScanReportSummaryStatisDto {
    /**
     * 
     * @type {Counts}
     * @memberof DmScanReportSummaryStatisDto
     */
    'grandTotal'?: Counts;
    /**
     * 
     * @type {Counts}
     * @memberof DmScanReportSummaryStatisDto
     */
    'today'?: Counts;
    /**
     * 
     * @type {Array<string>}
     * @memberof DmScanReportSummaryStatisDto
     */
    'activeClients'?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof DmScanReportSummaryStatisDto
     */
    'activeClientsCount'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof DmScanReportSummaryStatisDto
     */
    'fileCountsByDay'?: Array<number> | null;
    /**
     * 
     * @type {DateTimeDateTimeTuple}
     * @memberof DmScanReportSummaryStatisDto
     */
    'startEnd'?: DateTimeDateTimeTuple;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof DmScanReportSummaryStatisDto
     */
    'primaryClssDistribution'?: { [key: string]: number; } | null;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof DmScanReportSummaryStatisDto
     */
    'secondaryClssDistribution'?: { [key: string]: number; } | null;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof DmScanReportSummaryStatisDto
     */
    'documentTypeDistribution'?: { [key: string]: number; } | null;
}
/**
 * 
 * @export
 * @interface DmScanReportSummaryStatisQueryInput
 */
export interface DmScanReportSummaryStatisQueryInput {
    /**
     * 
     * @type {string}
     * @memberof DmScanReportSummaryStatisQueryInput
     */
    'notBefore'?: string;
    /**
     * 
     * @type {string}
     * @memberof DmScanReportSummaryStatisQueryInput
     */
    'notAfter'?: string;
    /**
     * 
     * @type {string}
     * @memberof DmScanReportSummaryStatisQueryInput
     */
    'ianaTimeZone'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DmScanReportSummaryStatisQueryInput
     */
    'clients'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface DmScanReportSummaryTableQueryInput
 */
export interface DmScanReportSummaryTableQueryInput {
    /**
     * 
     * @type {string}
     * @memberof DmScanReportSummaryTableQueryInput
     */
    'notBefore'?: string;
    /**
     * 
     * @type {string}
     * @memberof DmScanReportSummaryTableQueryInput
     */
    'notAfter'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DmScanReportSummaryTableQueryInput
     */
    'clients'?: Array<string> | null;
    /**
     * 
     * @type {Hint}
     * @memberof DmScanReportSummaryTableQueryInput
     */
    'pageHint'?: Hint;
    /**
     * 
     * @type {number}
     * @memberof DmScanReportSummaryTableQueryInput
     */
    'pageSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof DmScanReportSummaryTableQueryInput
     */
    'pageIndex'?: number;
}
/**
 * 
 * @export
 * @interface DocumentKeywordRule
 */
export interface DocumentKeywordRule {
    /**
     * 
     * @type {Array<string>}
     * @memberof DocumentKeywordRule
     */
    'words'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentKeywordRule
     */
    'regex'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentKeywordRule
     */
    'isRequired'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DocumentKeywordRule
     */
    'scoreAdjustment'?: number;
}
/**
 * 
 * @export
 * @interface DocumentTemplateInput
 */
export interface DocumentTemplateInput {
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplateInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplateInput
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplateInput
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplateInput
     */
    'template': string;
    /**
     * 
     * @type {Array<DocumentKeywordRule>}
     * @memberof DocumentTemplateInput
     */
    'keywordRules'?: Array<DocumentKeywordRule> | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentTemplateInput
     */
    'minScore'?: number;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplateInput
     */
    'extension': string;
    /**
     * 
     * @type {number}
     * @memberof DocumentTemplateInput
     */
    'templateFileSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof DocumentTemplateInput
     */
    'maxFileSize'?: number;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplateInput
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplateInput
     */
    'storagePath'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplateInput
     */
    'hash'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentTemplateInput
     */
    'isEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface DocumentTemplateResponseDto
 */
export interface DocumentTemplateResponseDto {
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplateResponseDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentTemplateResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplateResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplateResponseDto
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplateResponseDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplateResponseDto
     */
    'template'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentTemplateResponseDto
     */
    'minScore'?: number;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplateResponseDto
     */
    'extension'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentTemplateResponseDto
     */
    'templateFileSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof DocumentTemplateResponseDto
     */
    'maxFileSize'?: number;
    /**
     * 
     * @type {Array<DocumentKeywordRule>}
     * @memberof DocumentTemplateResponseDto
     */
    'keywordRules'?: Array<DocumentKeywordRule> | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentTemplateResponseDto
     */
    'ticks'?: number;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplateResponseDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplateResponseDto
     */
    'storagePath'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplateResponseDto
     */
    'hash'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplateResponseDto
     */
    'uri'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentTemplateResponseDto
     */
    'isEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface DocumentTemplatesDiffResponseDto
 */
export interface DocumentTemplatesDiffResponseDto {
    /**
     * 
     * @type {number}
     * @memberof DocumentTemplatesDiffResponseDto
     */
    'ticks'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentTemplatesDiffResponseDto
     */
    'changed'?: boolean;
    /**
     * 
     * @type {Array<DocumentTemplateResponseDto>}
     * @memberof DocumentTemplatesDiffResponseDto
     */
    'documentTemplates'?: Array<DocumentTemplateResponseDto> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DocumentTemplatesDiffResponseDto
     */
    'deletedNames'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface DrmSettingDto
 */
export interface DrmSettingDto {
    /**
     * 
     * @type {boolean}
     * @memberof DrmSettingDto
     */
    'drmAvailable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DrmSettingDto
     */
    'ssoConfigTenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DrmSettingDto
     */
    'ssoConfigClientId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DrmSettingDto
     */
    'ssoConfigClientSecret'?: string | null;
}
/**
 * 
 * @export
 * @interface EmailTargetDto
 */
export interface EmailTargetDto {
    /**
     * 
     * @type {number}
     * @memberof EmailTargetDto
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EmailTargetDto
     */
    'username'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailTargetDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailTargetDto
     */
    'lastName'?: string | null;
}
/**
 * 
 * @export
 * @interface EncryptFileInput
 */
export interface EncryptFileInput {
    /**
     * 
     * @type {string}
     * @memberof EncryptFileInput
     */
    'absolutePath': string;
    /**
     * 
     * @type {string}
     * @memberof EncryptFileInput
     */
    'originalFileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptFileInput
     */
    'machine': string;
    /**
     * 
     * @type {string}
     * @memberof EncryptFileInput
     */
    'appVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptFileInput
     */
    'unencryptedHash': string;
    /**
     * 
     * @type {number}
     * @memberof EncryptFileInput
     */
    'size'?: number;
    /**
     * 
     * @type {string}
     * @memberof EncryptFileInput
     */
    'keyContent': string;
}
/**
 * 
 * @export
 * @interface EncryptFileResponseDto
 */
export interface EncryptFileResponseDto {
    /**
     * 
     * @type {number}
     * @memberof EncryptFileResponseDto
     */
    'fileId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EncryptFileResponseDto
     */
    'fileKeyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EncryptFileResponseDto
     */
    'combId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptFileResponseDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EncryptFileResponseDto
     */
    'fileAuditId'?: number;
}
/**
 * 
 * @export
 * @interface EncryptionKeyResponseDto
 */
export interface EncryptionKeyResponseDto {
    /**
     * 
     * @type {number}
     * @memberof EncryptionKeyResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EncryptionKeyResponseDto
     */
    'encryptionKeyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EncryptionKeyResponseDto
     */
    'publicKey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptionKeyResponseDto
     */
    'createdTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncryptionKeyResponseDto
     */
    'modifiedTime'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EncryptionKeyResponseDto
     */
    'isDeleted'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum EntryStatus {
    Uploaded = 0,
    ManualClassified = 1
}

/**
 * 
 * @export
 * @interface ExcessiveDecryptSettingDto
 */
export interface ExcessiveDecryptSettingDto {
    /**
     * 
     * @type {number}
     * @memberof ExcessiveDecryptSettingDto
     */
    'timeRange'?: number;
    /**
     * 
     * @type {number}
     * @memberof ExcessiveDecryptSettingDto
     */
    'threshold'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof ExcessiveDecryptSettingDto
     */
    'roles'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ExcessiveDecryptSettingDto
     */
    'customRoles'?: Array<number> | null;
    /**
     * 
     * @type {Array<EmailTargetDto>}
     * @memberof ExcessiveDecryptSettingDto
     */
    'users'?: Array<EmailTargetDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ExcessiveDecryptSettingDto
     */
    'isEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface ExcessiveDecryptSettingInput
 */
export interface ExcessiveDecryptSettingInput {
    /**
     * 
     * @type {number}
     * @memberof ExcessiveDecryptSettingInput
     */
    'timeRange': number;
    /**
     * 
     * @type {number}
     * @memberof ExcessiveDecryptSettingInput
     */
    'threshold': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof ExcessiveDecryptSettingInput
     */
    'roles'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ExcessiveDecryptSettingInput
     */
    'customRoles'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ExcessiveDecryptSettingInput
     */
    'users'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ExcessiveDecryptSettingInput
     */
    'isEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface ExclusionRule
 */
export interface ExclusionRule {
    /**
     * 
     * @type {Array<string>}
     * @memberof ExclusionRule
     */
    'words'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ExclusionRule
     */
    'regex'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExclusionRule
     */
    'excludeInfoTypes'?: Array<string> | null;
    /**
     * 
     * @type {KeywordRule}
     * @memberof ExclusionRule
     */
    'excludeByKeyword'?: KeywordRule;
}
/**
 * 
 * @export
 * @interface ExtractDocumentResponseDto
 */
export interface ExtractDocumentResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ExtractDocumentResponseDto
     */
    'text'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtractDocumentResponseDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtractDocumentResponseDto
     */
    'storagePath'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtractDocumentResponseDto
     */
    'hash'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtractDocumentResponseDto
     */
    'taskId'?: string | null;
}
/**
 * 
 * @export
 * @interface FileAuditResponseDto
 */
export interface FileAuditResponseDto {
    /**
     * 
     * @type {number}
     * @memberof FileAuditResponseDto
     */
    'fileAuditId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileAuditResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileAuditResponseDto
     */
    'fileId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileAuditResponseDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileAuditResponseDto
     */
    'instanceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileAuditResponseDto
     */
    'path'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileAuditResponseDto
     */
    'machine'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileAuditResponseDto
     */
    'size'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileAuditResponseDto
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileAuditResponseDto
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileAuditResponseDto
     */
    'action'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileAuditResponseDto
     */
    'error'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileAuditResponseDto
     */
    'timeStamp'?: string;
    /**
     * 
     * @type {number}
     * @memberof FileAuditResponseDto
     */
    'sourceFileId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FileAuditResponseDto
     */
    'sourceInstanceId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FileAuditResponseDto
     */
    'sourceInstanceFileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileAuditResponseDto
     */
    'sourceInstancePath'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileAuditResponseDto
     */
    'sourceInstanceMachine'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileAuditResponseDto
     */
    'sourceInstanceUserId'?: number;
}
/**
 * 
 * @export
 * @interface FileAuditResponseDtoPaginationResult
 */
export interface FileAuditResponseDtoPaginationResult {
    /**
     * 
     * @type {Array<FileAuditResponseDto>}
     * @memberof FileAuditResponseDtoPaginationResult
     */
    'items'?: Array<FileAuditResponseDto> | null;
    /**
     * 
     * @type {number}
     * @memberof FileAuditResponseDtoPaginationResult
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface FileCatalogSearchInput
 */
export interface FileCatalogSearchInput {
    /**
     * 
     * @type {string}
     * @memberof FileCatalogSearchInput
     */
    'term'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof FileCatalogSearchInput
     */
    'tags'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof FileCatalogSearchInput
     */
    'primaryClassifications'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof FileCatalogSearchInput
     */
    'secondaryClassifications'?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof FileCatalogSearchInput
     */
    'startTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileCatalogSearchInput
     */
    'endTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileCatalogSearchInput
     */
    'userId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FileCatalogSearchInput
     */
    'machine'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileCatalogSearchInput
     */
    'pageSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileCatalogSearchInput
     */
    'pageIndex'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileCatalogSearchInput
     */
    'sortField'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FileCatalogSearchInput
     */
    'sortAscending'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof FileCatalogSearchInput
     */
    'documentTypes'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FileCatalogSearchInput
     */
    'infoTypes'?: Array<string> | null;
    /**
     * 
     * @type {FileInstanceOptions}
     * @memberof FileCatalogSearchInput
     */
    'fileInstanceOptions'?: FileInstanceOptions;
    /**
     * 
     * @type {Array<number>}
     * @memberof FileCatalogSearchInput
     */
    'ownerMatchIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof FileCatalogSearchInput
     */
    'dataOwnerGroupIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum FileInstanceOptions {
    All = 0,
    Single = 1,
    Multiple = 2
}

/**
 * 
 * @export
 * @interface FileInstanceResponseDto
 */
export interface FileInstanceResponseDto {
    /**
     * 
     * @type {number}
     * @memberof FileInstanceResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileInstanceResponseDto
     */
    'fileId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileInstanceResponseDto
     */
    'instanceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileInstanceResponseDto
     */
    'machine'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileInstanceResponseDto
     */
    'path'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileInstanceResponseDto
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileInstanceResponseDto
     */
    'userName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileInstanceResponseDto
     */
    'size'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileInstanceResponseDto
     */
    'lastModified'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FileInstanceResponseDto
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FileInstanceResponseDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileInstanceResponseDto
     */
    'unencryptedHash'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileInstanceResponseDto
     */
    'encryptionKeyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileInstanceResponseDto
     */
    'parentFileId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FileInstanceResponseDto
     */
    'parentFileName'?: string | null;
}
/**
 * 
 * @export
 * @interface FileInstanceResponseDtoPaginationResult
 */
export interface FileInstanceResponseDtoPaginationResult {
    /**
     * 
     * @type {Array<FileInstanceResponseDto>}
     * @memberof FileInstanceResponseDtoPaginationResult
     */
    'items'?: Array<FileInstanceResponseDto> | null;
    /**
     * 
     * @type {number}
     * @memberof FileInstanceResponseDtoPaginationResult
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface FileKeyResponseDto
 */
export interface FileKeyResponseDto {
    /**
     * 
     * @type {string}
     * @memberof FileKeyResponseDto
     */
    'key'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileKeyResponseDto
     */
    'fileAuditId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileKeyResponseDto
     */
    'fileViewId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileKeyResponseDto
     */
    'fileOfflineId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FileKeyResponseDto
     */
    'fileNameChanged'?: boolean;
    /**
     * 
     * @type {Array<FileInstanceResponseDto>}
     * @memberof FileKeyResponseDto
     */
    'fileInstances'?: Array<FileInstanceResponseDto> | null;
}
/**
 * 
 * @export
 * @interface FileOperationInput
 */
export interface FileOperationInput {
    /**
     * 
     * @type {number}
     * @memberof FileOperationInput
     */
    'fileId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileOperationInput
     */
    'action': string;
}
/**
 * 
 * @export
 * @interface FileRefDto
 */
export interface FileRefDto {
    /**
     * 
     * @type {number}
     * @memberof FileRefDto
     */
    'reportId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileRefDto
     */
    'fileId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileRefDto
     */
    'instanceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileRefDto
     */
    'path'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileRefDto
     */
    'machine'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileRefDto
     */
    'size'?: number;
}
/**
 * 
 * @export
 * @interface FileRefDtoPaginationResult
 */
export interface FileRefDtoPaginationResult {
    /**
     * 
     * @type {Array<FileRefDto>}
     * @memberof FileRefDtoPaginationResult
     */
    'items'?: Array<FileRefDto> | null;
    /**
     * 
     * @type {number}
     * @memberof FileRefDtoPaginationResult
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface FileRefsSearchInput
 */
export interface FileRefsSearchInput {
    /**
     * 
     * @type {string}
     * @memberof FileRefsSearchInput
     */
    'notBefore'?: string;
    /**
     * 
     * @type {string}
     * @memberof FileRefsSearchInput
     */
    'notAfter'?: string;
    /**
     * 
     * @type {number}
     * @memberof FileRefsSearchInput
     */
    'inReport'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FileRefsSearchInput
     */
    'protectedAtDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileRefsSearchInput
     */
    'protectedAtWeekOf'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileRefsSearchInput
     */
    'ianaTimeZone'?: string | null;
    /**
     * 
     * @type {PrimaryClassification}
     * @memberof FileRefsSearchInput
     */
    'classifiedAsPClss'?: PrimaryClassification;
    /**
     * 
     * @type {number}
     * @memberof FileRefsSearchInput
     */
    'classifiedAsSClss'?: number | null;
    /**
     * 
     * @type {ReportSummaryKind}
     * @memberof FileRefsSearchInput
     */
    'kind'?: ReportSummaryKind;
    /**
     * 
     * @type {Array<string>}
     * @memberof FileRefsSearchInput
     */
    'clients'?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof FileRefsSearchInput
     */
    'pageIndex'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileRefsSearchInput
     */
    'pageSize'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileRefsSearchInput
     */
    'pageHint'?: string | null;
}
/**
 * 
 * @export
 * @interface FileResponseDto
 */
export interface FileResponseDto {
    /**
     * 
     * @type {number}
     * @memberof FileResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileResponseDto
     */
    'fileId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileResponseDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileResponseDto
     */
    'unencryptedHash'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileResponseDto
     */
    'encryptionKeyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileResponseDto
     */
    'parentFileId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FileResponseDto
     */
    'parentFileName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FileResponseDto
     */
    'parentFileDeleted'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof FileResponseDto
     */
    'primaryClassification'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FileResponseDto
     */
    'secondaryClassificationId'?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof FileResponseDto
     */
    'tags'?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof FileResponseDto
     */
    'documentType'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FileResponseDto
     */
    'infoTypes'?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof FileResponseDto
     */
    'userId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FileResponseDto
     */
    'encryptedByUser'?: string | null;
    /**
     * 
     * @type {EntryStatus}
     * @memberof FileResponseDto
     */
    'entryStatus'?: EntryStatus;
    /**
     * 
     * @type {boolean}
     * @memberof FileResponseDto
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FileResponseDto
     */
    'ownerMatchId'?: number;
}
/**
 * 
 * @export
 * @interface FileResponseDtoPaginationResult
 */
export interface FileResponseDtoPaginationResult {
    /**
     * 
     * @type {Array<FileResponseDto>}
     * @memberof FileResponseDtoPaginationResult
     */
    'items'?: Array<FileResponseDto> | null;
    /**
     * 
     * @type {number}
     * @memberof FileResponseDtoPaginationResult
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface FileTagResponseDto
 */
export interface FileTagResponseDto {
    /**
     * 
     * @type {number}
     * @memberof FileTagResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileTagResponseDto
     */
    'tagId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileTagResponseDto
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface FileViewResponseDto
 */
export interface FileViewResponseDto {
    /**
     * 
     * @type {number}
     * @memberof FileViewResponseDto
     */
    'fileViewId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileViewResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileViewResponseDto
     */
    'fileId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileViewResponseDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileViewResponseDto
     */
    'instanceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileViewResponseDto
     */
    'path'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileViewResponseDto
     */
    'machine'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileViewResponseDto
     */
    'size'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileViewResponseDto
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileViewResponseDto
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileViewResponseDto
     */
    'error'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileViewResponseDto
     */
    'timeStamp'?: string;
}
/**
 * 
 * @export
 * @interface FileViewResponseDtoPaginationResult
 */
export interface FileViewResponseDtoPaginationResult {
    /**
     * 
     * @type {Array<FileViewResponseDto>}
     * @memberof FileViewResponseDtoPaginationResult
     */
    'items'?: Array<FileViewResponseDto> | null;
    /**
     * 
     * @type {number}
     * @memberof FileViewResponseDtoPaginationResult
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface GeneralSettingDto
 */
export interface GeneralSettingDto {
    /**
     * 
     * @type {number}
     * @memberof GeneralSettingDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralSettingDto
     */
    'efsEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralSettingDto
     */
    'offlineEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralSettingDto
     */
    'offlineAutoRemove'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralSettingDto
     */
    'dataAnalyzerOnpremise'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GeneralSettingDto
     */
    'maxOfflineTimes'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeneralSettingDto
     */
    'maxOfflineDays'?: number;
}
/**
 * 
 * @export
 * @interface GeneralSettingInput
 */
export interface GeneralSettingInput {
    /**
     * 
     * @type {number}
     * @memberof GeneralSettingInput
     */
    'organizationId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralSettingInput
     */
    'efsEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralSettingInput
     */
    'offlineEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralSettingInput
     */
    'offlineAutoRemove'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralSettingInput
     */
    'dataAnalyzerEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GeneralSettingInput
     */
    'maxOfflineTimes'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeneralSettingInput
     */
    'maxOfflineDays'?: number;
}
/**
 * 
 * @export
 * @interface Hint
 */
export interface Hint {
    /**
     * 
     * @type {string}
     * @memberof Hint
     */
    'pageEnd'?: string;
    /**
     * 
     * @type {number}
     * @memberof Hint
     */
    'pageIndex'?: number;
    /**
     * 
     * @type {number}
     * @memberof Hint
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface InfoTypeInput
 */
export interface InfoTypeInput {
    /**
     * 
     * @type {string}
     * @memberof InfoTypeInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof InfoTypeInput
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfoTypeInput
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfoTypeInput
     */
    'baseInfoType'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof InfoTypeInput
     */
    'denyList'?: Array<string> | null;
    /**
     * 
     * @type {Array<DetectPattern>}
     * @memberof InfoTypeInput
     */
    'detectPatterns'?: Array<DetectPattern> | null;
    /**
     * 
     * @type {Array<KeywordRule>}
     * @memberof InfoTypeInput
     */
    'keywordRules'?: Array<KeywordRule> | null;
    /**
     * 
     * @type {Array<ExclusionRule>}
     * @memberof InfoTypeInput
     */
    'exclusionRules'?: Array<ExclusionRule> | null;
    /**
     * 
     * @type {boolean}
     * @memberof InfoTypeInput
     */
    'isEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface InfoTypeResponseDto
 */
export interface InfoTypeResponseDto {
    /**
     * 
     * @type {string}
     * @memberof InfoTypeResponseDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfoTypeResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfoTypeResponseDto
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfoTypeResponseDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfoTypeResponseDto
     */
    'baseInfoType'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof InfoTypeResponseDto
     */
    'isBuiltIn'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof InfoTypeResponseDto
     */
    'denyList'?: Array<string> | null;
    /**
     * 
     * @type {Array<DetectPattern>}
     * @memberof InfoTypeResponseDto
     */
    'detectPatterns'?: Array<DetectPattern> | null;
    /**
     * 
     * @type {Array<KeywordRule>}
     * @memberof InfoTypeResponseDto
     */
    'keywordRules'?: Array<KeywordRule> | null;
    /**
     * 
     * @type {Array<ExclusionRule>}
     * @memberof InfoTypeResponseDto
     */
    'exclusionRules'?: Array<ExclusionRule> | null;
    /**
     * 
     * @type {number}
     * @memberof InfoTypeResponseDto
     */
    'ticks'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof InfoTypeResponseDto
     */
    'isNer'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InfoTypeResponseDto
     */
    'isEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface InfoTypesDiffResponseDto
 */
export interface InfoTypesDiffResponseDto {
    /**
     * 
     * @type {number}
     * @memberof InfoTypesDiffResponseDto
     */
    'ticks'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof InfoTypesDiffResponseDto
     */
    'changed'?: boolean;
    /**
     * 
     * @type {Array<InfoTypeResponseDto>}
     * @memberof InfoTypesDiffResponseDto
     */
    'infoTypes'?: Array<InfoTypeResponseDto> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof InfoTypesDiffResponseDto
     */
    'deletedNames'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface JsonWebKey
 */
export interface JsonWebKey {
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'alg'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'crv'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'd'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'dp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'dq'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'e'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'k'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonWebKey
     */
    'key_ops'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'kid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'kty'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'n'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonWebKey
     */
    'oth'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'p'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'q'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'qi'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'use'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'x'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonWebKey
     */
    'x5c'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'x5t'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'x5t#S256'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'x5u'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'y'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof JsonWebKey
     */
    'keySize'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof JsonWebKey
     */
    'hasPrivateKey'?: boolean;
}
/**
 * 
 * @export
 * @interface JsonWebKeySet
 */
export interface JsonWebKeySet {
    /**
     * 
     * @type {Array<JsonWebKey>}
     * @memberof JsonWebKeySet
     */
    'keys'?: Array<JsonWebKey> | null;
}
/**
 * 
 * @export
 * @interface KeywordRule
 */
export interface KeywordRule {
    /**
     * 
     * @type {Array<string>}
     * @memberof KeywordRule
     */
    'words'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof KeywordRule
     */
    'regex'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof KeywordRule
     */
    'windowBefore'?: number;
    /**
     * 
     * @type {number}
     * @memberof KeywordRule
     */
    'windowAfter'?: number;
    /**
     * 
     * @type {number}
     * @memberof KeywordRule
     */
    'scoreAdjustment'?: number;
}
/**
 * 
 * @export
 * @interface LegalSettingDto
 */
export interface LegalSettingDto {
    /**
     * 
     * @type {number}
     * @memberof LegalSettingDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof LegalSettingDto
     */
    'showLegalWarning'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LegalSettingDto
     */
    'decryptionLegalWarning'?: string | null;
}
/**
 * 
 * @export
 * @interface LegalSettingInput
 */
export interface LegalSettingInput {
    /**
     * 
     * @type {number}
     * @memberof LegalSettingInput
     */
    'organizationId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof LegalSettingInput
     */
    'showLegalWarning'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LegalSettingInput
     */
    'decryptionLegalWarning'?: string | null;
}
/**
 * 
 * @export
 * @interface OcrApiResultDto
 */
export interface OcrApiResultDto {
    /**
     * 
     * @type {string}
     * @memberof OcrApiResultDto
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OcrApiResultDto
     */
    'text'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OcrApiResultDto
     */
    'error'?: string | null;
}
/**
 * 
 * @export
 * @interface OfflineFileInput
 */
export interface OfflineFileInput {
    /**
     * 
     * @type {number}
     * @memberof OfflineFileInput
     */
    'fileId'?: number;
    /**
     * 
     * @type {number}
     * @memberof OfflineFileInput
     */
    'fileKeyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof OfflineFileInput
     */
    'combId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OfflineFileInput
     */
    'fileOfflineId'?: number;
    /**
     * 
     * @type {string}
     * @memberof OfflineFileInput
     */
    'appVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OfflineFileInput
     */
    'absolutePath': string;
    /**
     * 
     * @type {string}
     * @memberof OfflineFileInput
     */
    'machine': string;
    /**
     * 
     * @type {string}
     * @memberof OfflineFileInput
     */
    'publicKey': string;
    /**
     * 
     * @type {number}
     * @memberof OfflineFileInput
     */
    'size'?: number;
    /**
     * 
     * @type {number}
     * @memberof OfflineFileInput
     */
    'accessCountMax'?: number;
    /**
     * 
     * @type {number}
     * @memberof OfflineFileInput
     */
    'accessCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof OfflineFileInput
     */
    'accessBeginTime'?: number;
    /**
     * 
     * @type {number}
     * @memberof OfflineFileInput
     */
    'accessEndTime'?: number;
}
/**
 * 
 * @export
 * @interface OfflineFileResponseDto
 */
export interface OfflineFileResponseDto {
    /**
     * 
     * @type {number}
     * @memberof OfflineFileResponseDto
     */
    'offlineFileId'?: number;
    /**
     * 
     * @type {string}
     * @memberof OfflineFileResponseDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OfflineFileResponseDto
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof OfflineFileResponseDto
     */
    'username'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OfflineFileResponseDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OfflineFileResponseDto
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OfflineFileResponseDto
     */
    'fileId'?: number;
    /**
     * 
     * @type {string}
     * @memberof OfflineFileResponseDto
     */
    'machine'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OfflineFileResponseDto
     */
    'path'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OfflineFileResponseDto
     */
    'accessBeginTime'?: number;
    /**
     * 
     * @type {number}
     * @memberof OfflineFileResponseDto
     */
    'accessEndTime'?: number;
    /**
     * 
     * @type {number}
     * @memberof OfflineFileResponseDto
     */
    'accessCountMax'?: number;
    /**
     * 
     * @type {number}
     * @memberof OfflineFileResponseDto
     */
    'accessCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof OfflineFileResponseDto
     */
    'createdTime'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OfflineFileResponseDto
     */
    'isDeleted'?: boolean;
}
/**
 * 
 * @export
 * @interface OfflineFileResponseDtoPaginationResult
 */
export interface OfflineFileResponseDtoPaginationResult {
    /**
     * 
     * @type {Array<OfflineFileResponseDto>}
     * @memberof OfflineFileResponseDtoPaginationResult
     */
    'items'?: Array<OfflineFileResponseDto> | null;
    /**
     * 
     * @type {number}
     * @memberof OfflineFileResponseDtoPaginationResult
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface OfflineFileSearchInput
 */
export interface OfflineFileSearchInput {
    /**
     * 
     * @type {string}
     * @memberof OfflineFileSearchInput
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OfflineFileSearchInput
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof OfflineFileSearchInput
     */
    'endTime'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OfflineFileSearchInput
     */
    'completed'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof OfflineFileSearchInput
     */
    'pageSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof OfflineFileSearchInput
     */
    'pageIndex'?: number;
}
/**
 * 
 * @export
 * @interface OwnerMatchRuleDto
 */
export interface OwnerMatchRuleDto {
    /**
     * 
     * @type {number}
     * @memberof OwnerMatchRuleDto
     */
    'ownerMatchId'?: number;
    /**
     * 
     * @type {number}
     * @memberof OwnerMatchRuleDto
     */
    'kind'?: number;
    /**
     * 
     * @type {string}
     * @memberof OwnerMatchRuleDto
     */
    'computer'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OwnerMatchRuleDto
     */
    'pathPrefix'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OwnerMatchRuleDto
     */
    'dataOwnerGroupId'?: number;
    /**
     * 
     * @type {number}
     * @memberof OwnerMatchRuleDto
     */
    'priority'?: number;
    /**
     * 
     * @type {string}
     * @memberof OwnerMatchRuleDto
     */
    'createdAt'?: string;
}
/**
 * 
 * @export
 * @interface PlainFileScanInstanceResponseDto
 */
export interface PlainFileScanInstanceResponseDto {
    /**
     * 
     * @type {number}
     * @memberof PlainFileScanInstanceResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PlainFileScanInstanceResponseDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlainFileScanInstanceResponseDto
     */
    'unencryptedHash'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PlainFileScanInstanceResponseDto
     */
    'instanceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PlainFileScanInstanceResponseDto
     */
    'clientId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlainFileScanInstanceResponseDto
     */
    'filePath'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlainFileScanInstanceResponseDto
     */
    'machine'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PlainFileScanInstanceResponseDto
     */
    'size'?: number;
    /**
     * 
     * @type {string}
     * @memberof PlainFileScanInstanceResponseDto
     */
    'lastModified'?: string;
}
/**
 * 
 * @export
 * @interface PlainFileScanInstanceResponseDtoPaginationResult
 */
export interface PlainFileScanInstanceResponseDtoPaginationResult {
    /**
     * 
     * @type {Array<PlainFileScanInstanceResponseDto>}
     * @memberof PlainFileScanInstanceResponseDtoPaginationResult
     */
    'items'?: Array<PlainFileScanInstanceResponseDto> | null;
    /**
     * 
     * @type {number}
     * @memberof PlainFileScanInstanceResponseDtoPaginationResult
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface PlainFileScanResponseDto
 */
export interface PlainFileScanResponseDto {
    /**
     * 
     * @type {number}
     * @memberof PlainFileScanResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PlainFileScanResponseDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlainFileScanResponseDto
     */
    'unencryptedHash'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PlainFileScanResponseDto
     */
    'primaryClassification'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PlainFileScanResponseDto
     */
    'secondaryClassificationId'?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof PlainFileScanResponseDto
     */
    'tags'?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof PlainFileScanResponseDto
     */
    'documentType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlainFileScanResponseDto
     */
    'infoTypes'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PlainFileScanResponseDto
     */
    'infoTypesArr'?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof PlainFileScanResponseDto
     */
    'entryId'?: number;
    /**
     * 
     * @type {EntryStatus}
     * @memberof PlainFileScanResponseDto
     */
    'entryStatus'?: EntryStatus;
    /**
     * 
     * @type {boolean}
     * @memberof PlainFileScanResponseDto
     */
    'multipleInstance'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PlainFileScanResponseDto
     */
    'ownerMatchId'?: number;
}
/**
 * 
 * @export
 * @interface PlainFileScanResponseDtoPaginationResult
 */
export interface PlainFileScanResponseDtoPaginationResult {
    /**
     * 
     * @type {Array<PlainFileScanResponseDto>}
     * @memberof PlainFileScanResponseDtoPaginationResult
     */
    'items'?: Array<PlainFileScanResponseDto> | null;
    /**
     * 
     * @type {number}
     * @memberof PlainFileScanResponseDtoPaginationResult
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum PrimaryClassification {
    Public = 0,
    Sensitive = 1,
    Confidential = 2,
    Regulated = 3
}

/**
 * 
 * @export
 * @interface PrimaryClassificationStatisticsResponseDto
 */
export interface PrimaryClassificationStatisticsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof PrimaryClassificationStatisticsResponseDto
     */
    'publicCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PrimaryClassificationStatisticsResponseDto
     */
    'sensitiveCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PrimaryClassificationStatisticsResponseDto
     */
    'confidentialCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PrimaryClassificationStatisticsResponseDto
     */
    'regulatedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PrimaryClassificationStatisticsResponseDto
     */
    'unclassifiedCount'?: number;
}
/**
 * 
 * @export
 * @interface ProtectionRuleDirectivesDto
 */
export interface ProtectionRuleDirectivesDto {
    /**
     * 
     * @type {number}
     * @memberof ProtectionRuleDirectivesDto
     */
    'ruleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProtectionRuleDirectivesDto
     */
    'ruleDirectiveTree'?: string | null;
}
/**
 * 
 * @export
 * @interface ProtectionRuleDirectivesQueryResult
 */
export interface ProtectionRuleDirectivesQueryResult {
    /**
     * 
     * @type {boolean}
     * @memberof ProtectionRuleDirectivesQueryResult
     */
    'cacheUnchanged'?: boolean;
    /**
     * 
     * @type {Array<ProtectionRuleDirectivesDto>}
     * @memberof ProtectionRuleDirectivesQueryResult
     */
    'ruleDirectives'?: Array<ProtectionRuleDirectivesDto> | null;
}
/**
 * 
 * @export
 * @interface ProtectionRuleDto
 */
export interface ProtectionRuleDto {
    /**
     * 
     * @type {number}
     * @memberof ProtectionRuleDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProtectionRuleDto
     */
    'ruleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProtectionRuleDto
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProtectionRuleDto
     */
    'ruleDisplayTree'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProtectionRuleDto
     */
    'comment'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProtectionRuleDto
     */
    'activeRule'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProtectionRuleDto
     */
    'createTime'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProtectionRuleDto
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProtectionRuleDto
     */
    'predecessorId'?: number | null;
}
/**
 * 
 * @export
 * @interface ProtectionRuleInput
 */
export interface ProtectionRuleInput {
    /**
     * 
     * @type {number}
     * @memberof ProtectionRuleInput
     */
    'ruleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProtectionRuleInput
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof ProtectionRuleInput
     */
    'ruleDisplayTree': string;
    /**
     * 
     * @type {string}
     * @memberof ProtectionRuleInput
     */
    'comment'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProtectionRuleInput
     */
    'activeRule'?: boolean;
}
/**
 * 
 * @export
 * @interface ReadFileInput
 */
export interface ReadFileInput {
    /**
     * 
     * @type {number}
     * @memberof ReadFileInput
     */
    'fileId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReadFileInput
     */
    'fileKeyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReadFileInput
     */
    'combId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadFileInput
     */
    'appVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadFileInput
     */
    'absolutePath': string;
    /**
     * 
     * @type {string}
     * @memberof ReadFileInput
     */
    'machine': string;
    /**
     * 
     * @type {string}
     * @memberof ReadFileInput
     */
    'publicKey': string;
    /**
     * 
     * @type {number}
     * @memberof ReadFileInput
     */
    'size'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ReadFileInput
     */
    'isMac'?: boolean | null;
}
/**
 * 
 * @export
 * @interface RenameFileInput
 */
export interface RenameFileInput {
    /**
     * 
     * @type {number}
     * @memberof RenameFileInput
     */
    'fileId'?: number;
    /**
     * 
     * @type {number}
     * @memberof RenameFileInput
     */
    'fileKeyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RenameFileInput
     */
    'absolutePath': string;
    /**
     * 
     * @type {string}
     * @memberof RenameFileInput
     */
    'machine': string;
    /**
     * 
     * @type {number}
     * @memberof RenameFileInput
     */
    'size'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum ReportSummaryKind {
    EncryptedFile = 0,
    PlainFile = 1
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum RuleRowState {
    Normal = 0,
    PreAdd = 1,
    PreDelete = 2,
    ChangePending = 3,
    Deleted = 4
}

/**
 * 
 * @export
 * @interface ScanJobProgressReportDto
 */
export interface ScanJobProgressReportDto {
    /**
     * 
     * @type {string}
     * @memberof ScanJobProgressReportDto
     */
    'machine'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ScanJobProgressReportDto
     */
    'latestScanJobId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ScanJobProgressReportDto
     */
    'latestScanStart'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScanJobProgressReportDto
     */
    'lastScanEnd'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ScanJobProgressReportDto
     */
    'isDone'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ScanJobProgressReportDto
     */
    'inaccessibleFolders'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScanJobProgressReportDto
     */
    'inaccessibleFiles'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScanJobProgressReportDto
     */
    'filesScannedCount'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScanJobProgressReportDto
     */
    'countUpdatedAt'?: string | null;
}
/**
 * 
 * @export
 * @interface ScannedFile
 */
export interface ScannedFile {
    /**
     * 
     * @type {string}
     * @memberof ScannedFile
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof ScannedFile
     */
    'fullPath': string;
    /**
     * 
     * @type {string}
     * @memberof ScannedFile
     */
    'lastModifyTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof ScannedFile
     */
    'length': number;
    /**
     * 
     * @type {string}
     * @memberof ScannedFile
     */
    'crucialHash': string;
    /**
     * 
     * @type {string}
     * @memberof ScannedFile
     */
    'computer'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScannedFile
     */
    'documentType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScannedFile
     */
    'infoTypes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ScannedFile
     */
    'prevailedPRuleId': number;
    /**
     * 
     * @type {number}
     * @memberof ScannedFile
     */
    'osfFileId': number;
}
/**
 * 
 * @export
 * @interface ScannedFilesReport
 */
export interface ScannedFilesReport {
    /**
     * 
     * @type {Array<ScannedFile>}
     * @memberof ScannedFilesReport
     */
    'scannedFiles'?: Array<ScannedFile> | null;
    /**
     * 
     * @type {string}
     * @memberof ScannedFilesReport
     */
    'startTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScannedFilesReport
     */
    'endTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ScannedFilesReport
     */
    'duration'?: number | null;
}
/**
 * 
 * @export
 * @interface SearchFileCatalogResponseDto
 */
export interface SearchFileCatalogResponseDto {
    /**
     * 
     * @type {FileResponseDtoPaginationResult}
     * @memberof SearchFileCatalogResponseDto
     */
    'paginationResult'?: FileResponseDtoPaginationResult;
    /**
     * 
     * @type {PrimaryClassificationStatisticsResponseDto}
     * @memberof SearchFileCatalogResponseDto
     */
    'primaryClassificationStatis'?: PrimaryClassificationStatisticsResponseDto;
}
/**
 * 
 * @export
 * @interface SearchFileCatalogResponseDto2
 */
export interface SearchFileCatalogResponseDto2 {
    /**
     * 
     * @type {PlainFileScanResponseDtoPaginationResult}
     * @memberof SearchFileCatalogResponseDto2
     */
    'paginationResult'?: PlainFileScanResponseDtoPaginationResult;
    /**
     * 
     * @type {PrimaryClassificationStatisticsResponseDto}
     * @memberof SearchFileCatalogResponseDto2
     */
    'primaryClassificationStatis'?: PrimaryClassificationStatisticsResponseDto;
}
/**
 * 
 * @export
 * @interface SearchInput
 */
export interface SearchInput {
    /**
     * 
     * @type {string}
     * @memberof SearchInput
     */
    'term'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof SearchInput
     */
    'tags'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof SearchInput
     */
    'primaryClassifications'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof SearchInput
     */
    'secondaryClassifications'?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof SearchInput
     */
    'startTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchInput
     */
    'endTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SearchInput
     */
    'userId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SearchInput
     */
    'machine'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SearchInput
     */
    'pageSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchInput
     */
    'pageIndex'?: number;
    /**
     * 
     * @type {string}
     * @memberof SearchInput
     */
    'sortField'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SearchInput
     */
    'sortAscending'?: boolean;
}
/**
 * 
 * @export
 * @interface SetErrorInput
 */
export interface SetErrorInput {
    /**
     * 
     * @type {number}
     * @memberof SetErrorInput
     */
    'fileViewId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SetErrorInput
     */
    'fileAuditId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SetErrorInput
     */
    'error'?: string | null;
}
/**
 * 
 * @export
 * @interface SettingDto
 */
export interface SettingDto {
    /**
     * 
     * @type {number}
     * @memberof SettingDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SettingDto
     */
    'efsEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SettingDto
     */
    'showLegalWarning'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SettingDto
     */
    'decryptionLegalWarning'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SettingDto
     */
    'offlineEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SettingDto
     */
    'offlineAutoRemove'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SettingDto
     */
    'dataAnalyzerOnpremise'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SettingDto
     */
    'maxOfflineTimes'?: number;
    /**
     * 
     * @type {number}
     * @memberof SettingDto
     */
    'maxOfflineDays'?: number;
}
/**
 * 
 * @export
 * @interface SsoAccessTokenResponseDto
 */
export interface SsoAccessTokenResponseDto {
    /**
     * 
     * @type {number}
     * @memberof SsoAccessTokenResponseDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof SsoAccessTokenResponseDto
     */
    'ssoAccessToken'?: string | null;
}
/**
 * 
 * @export
 * @interface SummaryClassificationStatisBag
 */
export interface SummaryClassificationStatisBag {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof SummaryClassificationStatisBag
     */
    'primaryClassification'?: { [key: string]: number; } | null;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof SummaryClassificationStatisBag
     */
    'secondaryClassification'?: { [key: string]: number; } | null;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof SummaryClassificationStatisBag
     */
    'documentType'?: { [key: string]: number; } | null;
}
/**
 * 
 * @export
 * @interface TrialResultStatisDto
 */
export interface TrialResultStatisDto {
    /**
     * 
     * @type {number}
     * @memberof TrialResultStatisDto
     */
    'trialId'?: number;
    /**
     * 
     * @type {number}
     * @memberof TrialResultStatisDto
     */
    'comparedRuleSetVersion'?: number;
    /**
     * 
     * @type {number}
     * @memberof TrialResultStatisDto
     */
    'trialCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof TrialResultStatisDto
     */
    'totalCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof TrialResultStatisDto
     */
    'igoredCount'?: number;
    /**
     * 
     * @type {Array<DataPoint>}
     * @memberof TrialResultStatisDto
     */
    'ruleSetStatis'?: Array<DataPoint> | null;
    /**
     * 
     * @type {Array<DataPoint>}
     * @memberof TrialResultStatisDto
     */
    'trialStatis'?: Array<DataPoint> | null;
}
/**
 * 
 * @export
 * @interface TrialRuleSetOptionDto
 */
export interface TrialRuleSetOptionDto {
    /**
     * 
     * @type {number}
     * @memberof TrialRuleSetOptionDto
     */
    'recordsCount': number;
}
/**
 * 
 * @export
 * @interface UpdateFileInput
 */
export interface UpdateFileInput {
    /**
     * 
     * @type {number}
     * @memberof UpdateFileInput
     */
    'fileId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateFileInput
     */
    'primaryClassification'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateFileInput
     */
    'secondaryClassificationId'?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateFileInput
     */
    'tags'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface UpdateOwnerMatchRuleInput
 */
export interface UpdateOwnerMatchRuleInput {
    /**
     * 
     * @type {string}
     * @memberof UpdateOwnerMatchRuleInput
     */
    'pathPrefix'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateOwnerMatchRuleInput
     */
    'dataOwnerGroupId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateOwnerMatchRuleInput
     */
    'priority'?: number | null;
}
/**
 * 
 * @export
 * @interface UploadedAutoEncryptReport
 */
export interface UploadedAutoEncryptReport {
    /**
     * 
     * @type {Array<ScannedFile>}
     * @memberof UploadedAutoEncryptReport
     */
    'scannedFiles'?: Array<ScannedFile> | null;
    /**
     * 
     * @type {string}
     * @memberof UploadedAutoEncryptReport
     */
    'startTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UploadedAutoEncryptReport
     */
    'endTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UploadedAutoEncryptReport
     */
    'duration'?: number | null;
}
/**
 * 
 * @export
 * @interface WriteFileInput
 */
export interface WriteFileInput {
    /**
     * 
     * @type {number}
     * @memberof WriteFileInput
     */
    'fileId'?: number;
    /**
     * 
     * @type {string}
     * @memberof WriteFileInput
     */
    'absolutePath': string;
    /**
     * 
     * @type {string}
     * @memberof WriteFileInput
     */
    'machine': string;
    /**
     * 
     * @type {number}
     * @memberof WriteFileInput
     */
    'size'?: number;
}

/**
 * SecureFilesApi - axios parameter creator
 * @export
 */
export const SecureFilesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomkeyvaultsDisablePost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/customkeyvaults/disable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CustomKeyVaultInput} [customKeyVaultInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomkeyvaultsEnablePost: async (customKeyVaultInput?: CustomKeyVaultInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/customkeyvaults/enable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customKeyVaultInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomkeyvaultsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/customkeyvaults`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeBaseinfotypesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dataanalyze/baseinfotypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDocumenttemplatesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dataanalyze/documenttemplates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDocumenttemplatesIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDataanalyzeDocumenttemplatesIdDelete', 'id', id)
            const localVarPath = `/api/dataanalyze/documenttemplates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDocumenttemplatesIdDownloadGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDataanalyzeDocumenttemplatesIdDownloadGet', 'id', id)
            const localVarPath = `/api/dataanalyze/documenttemplates/{id}/download`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDocumenttemplatesIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDataanalyzeDocumenttemplatesIdGet', 'id', id)
            const localVarPath = `/api/dataanalyze/documenttemplates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {DocumentTemplateInput} [documentTemplateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDocumenttemplatesIdPut: async (id: string, documentTemplateInput?: DocumentTemplateInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDataanalyzeDocumenttemplatesIdPut', 'id', id)
            const localVarPath = `/api/dataanalyze/documenttemplates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentTemplateInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDocumenttemplatesOcrresultIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDataanalyzeDocumenttemplatesOcrresultIdGet', 'id', id)
            const localVarPath = `/api/dataanalyze/documenttemplates/ocrresult/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DocumentTemplateInput} [documentTemplateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDocumenttemplatesPost: async (documentTemplateInput?: DocumentTemplateInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dataanalyze/documenttemplates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentTemplateInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {any} [templateFile] 
         * @param {string} [id] 
         * @param {boolean} [isImage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDocumenttemplatesUploadPost: async (templateFile?: any, id?: string, isImage?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dataanalyze/documenttemplates/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (templateFile !== undefined) { 
                localVarFormParams.append('TemplateFile', templateFile as any);
            }
    
            if (id !== undefined) { 
                localVarFormParams.append('Id', id as any);
            }
    
            if (isImage !== undefined) { 
                localVarFormParams.append('IsImage', isImage as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeInfotypesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dataanalyze/infotypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeInfotypesIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDataanalyzeInfotypesIdDelete', 'id', id)
            const localVarPath = `/api/dataanalyze/infotypes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeInfotypesIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDataanalyzeInfotypesIdGet', 'id', id)
            const localVarPath = `/api/dataanalyze/infotypes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {InfoTypeInput} [infoTypeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeInfotypesIdPut: async (id: string, infoTypeInput?: InfoTypeInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDataanalyzeInfotypesIdPut', 'id', id)
            const localVarPath = `/api/dataanalyze/infotypes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(infoTypeInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InfoTypeInput} [infoTypeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeInfotypesPost: async (infoTypeInput?: InfoTypeInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dataanalyze/infotypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(infoTypeInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzePullPasswordPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dataanalyze/pull-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeRepoAuthnInfoGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dataanalyze/repo-authn-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SearchInput} [searchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesAccessSearchPost: async (searchInput?: SearchInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/access/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SearchInput} [searchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesAccessUserOptionsPost: async (searchInput?: SearchInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/access/user-options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesAnalyzerIsconfiguredGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/analyzer/isconfigured`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesAnalyzersettingDisableAnalyzerPut: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/analyzersetting/disable-analyzer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesAnalyzersettingGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/analyzersetting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DataAnalyzerSettingDto} [dataAnalyzerSettingDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesAnalyzersettingPost: async (dataAnalyzerSettingDto?: DataAnalyzerSettingDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/analyzersetting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dataAnalyzerSettingDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesAuditMachineOptionsPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/audit/machine-options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SearchInput} [searchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesAuditSearchPost: async (searchInput?: SearchInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/audit/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SearchInput} [searchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesAuditUserOptionsPost: async (searchInput?: SearchInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/audit/user-options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkUpdateFileInput} [bulkUpdateFileInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesBulkupdatePost: async (bulkUpdateFileInput?: BulkUpdateFileInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/bulkupdate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUpdateFileInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [clientId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesClientsettingGet: async (clientId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/clientsetting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clientId !== undefined) {
                localVarQueryParameter['clientId'] = clientId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ClientSettingDto} [clientSettingDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesClientsettingPost: async (clientSettingDto?: ClientSettingDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/clientsetting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientSettingDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesClientsettingQuerybyidsPost: async (requestBody?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/clientsetting/querybyids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ClientSettingDto} [clientSettingDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesClientsettingRescanPost: async (clientSettingDto?: ClientSettingDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/clientsetting/rescan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientSettingDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [forPlainFile] 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesDataOwnerGroupsQueryManyPost: async (forPlainFile?: boolean, requestBody?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/data-owner-groups/query-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (forPlainFile !== undefined) {
                localVarQueryParameter['forPlainFile'] = forPlainFile;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesExportPlainFileScanDownloadGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/exportPlainFileScan-download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FileCatalogSearchInput} [fileCatalogSearchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesExportPlainFileScanPost: async (fileCatalogSearchInput?: FileCatalogSearchInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/exportPlainFileScan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileCatalogSearchInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesExportPlainFileScanWithInstanceDownloadGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/exportPlainFileScanWithInstance-download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FileCatalogSearchInput} [fileCatalogSearchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesExportPlainFileScanWithInstancePost: async (fileCatalogSearchInput?: FileCatalogSearchInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/exportPlainFileScanWithInstance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileCatalogSearchInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FileCatalogSearchInput} [fileCatalogSearchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesExportPost: async (fileCatalogSearchInput?: FileCatalogSearchInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileCatalogSearchInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FileCatalogSearchInput} [fileCatalogSearchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesExportWithInstancePost: async (fileCatalogSearchInput?: FileCatalogSearchInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/exportWithInstance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileCatalogSearchInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} fileId 
         * @param {boolean} [showDelete] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesFileIdGet: async (fileId: number, showDelete?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('apiFilesFileIdGet', 'fileId', fileId)
            const localVarPath = `/api/files/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (showDelete !== undefined) {
                localVarQueryParameter['showDelete'] = showDelete;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} fileId 
         * @param {boolean} [isPlainFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesFileIdInstancesCountGet: async (fileId: number, isPlainFile?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('apiFilesFileIdInstancesCountGet', 'fileId', fileId)
            const localVarPath = `/api/files/{fileId}/instances/count`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isPlainFile !== undefined) {
                localVarQueryParameter['isPlainFile'] = isPlainFile;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} fileId 
         * @param {number} [pageSize] 
         * @param {number} [pageIndex] 
         * @param {boolean} [showDelete] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesFileIdInstancesGet: async (fileId: number, pageSize?: number, pageIndex?: number, showDelete?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('apiFilesFileIdInstancesGet', 'fileId', fileId)
            const localVarPath = `/api/files/{fileId}/instances`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['pageIndex'] = pageIndex;
            }

            if (showDelete !== undefined) {
                localVarQueryParameter['showDelete'] = showDelete;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} fileId 
         * @param {UpdateFileInput} [updateFileInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesFileIdPut: async (fileId: number, updateFileInput?: UpdateFileInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('apiFilesFileIdPut', 'fileId', fileId)
            const localVarPath = `/api/files/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFileInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesGeneralsettingGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/generalsetting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GeneralSettingInput} [generalSettingInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesGeneralsettingPost: async (generalSettingInput?: GeneralSettingInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/generalsetting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalSettingInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesLegalsettingGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/legalsetting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LegalSettingInput} [legalSettingInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesLegalsettingPost: async (legalSettingInput?: LegalSettingInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/legalsetting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(legalSettingInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OfflineFileSearchInput} [offlineFileSearchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesOfflinefilesSearchPost: async (offlineFileSearchInput?: OfflineFileSearchInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/offlinefiles/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(offlineFileSearchInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [forPlainFiles] 
         * @param {FileCatalogSearchInput} [fileCatalogSearchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesOwnershipStatisPost: async (forPlainFiles?: boolean, fileCatalogSearchInput?: FileCatalogSearchInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/ownership/statis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (forPlainFiles !== undefined) {
                localVarQueryParameter['forPlainFiles'] = forPlainFiles;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileCatalogSearchInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkUpdateFileInput} [bulkUpdateFileInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesPlainFileScansBulkupdatePost: async (bulkUpdateFileInput?: BulkUpdateFileInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/plainFileScans/bulkupdate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUpdateFileInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} entryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesPlainFileScansEntryIdGet: async (entryId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entryId' is not null or undefined
            assertParamExists('apiFilesPlainFileScansEntryIdGet', 'entryId', entryId)
            const localVarPath = `/api/files/plainFileScans/{entryId}`
                .replace(`{${"entryId"}}`, encodeURIComponent(String(entryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} entryId 
         * @param {number} [pageSize] 
         * @param {number} [pageIndex] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesPlainFileScansEntryIdInstancesGet: async (entryId: number, pageSize?: number, pageIndex?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entryId' is not null or undefined
            assertParamExists('apiFilesPlainFileScansEntryIdInstancesGet', 'entryId', entryId)
            const localVarPath = `/api/files/plainFileScans/{entryId}/instances`
                .replace(`{${"entryId"}}`, encodeURIComponent(String(entryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['pageIndex'] = pageIndex;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} entryId 
         * @param {UpdateFileInput} [updateFileInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesPlainFileScansEntryIdPut: async (entryId: number, updateFileInput?: UpdateFileInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entryId' is not null or undefined
            assertParamExists('apiFilesPlainFileScansEntryIdPut', 'entryId', entryId)
            const localVarPath = `/api/files/plainFileScans/{entryId}`
                .replace(`{${"entryId"}}`, encodeURIComponent(String(entryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFileInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FileCatalogSearchInput} [fileCatalogSearchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesSearchPlainFileScanPost: async (fileCatalogSearchInput?: FileCatalogSearchInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/searchPlainFileScan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileCatalogSearchInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FileCatalogSearchInput} [fileCatalogSearchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesSearchPost: async (fileCatalogSearchInput?: FileCatalogSearchInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileCatalogSearchInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesTagsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddFileTagInput} [addFileTagInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesTagsPost: async (addFileTagInput?: AddFileTagInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addFileTagInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOwnerMatchRulesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/owner-match-rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {{ [key: string]: number; }} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOwnerMatchRulesMultipleReprioritizePost: async (requestBody?: { [key: string]: number; }, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/owner-match-rules/multiple-reprioritize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} ownerMatchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOwnerMatchRulesOwnerMatchIdDelete: async (ownerMatchId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ownerMatchId' is not null or undefined
            assertParamExists('apiOwnerMatchRulesOwnerMatchIdDelete', 'ownerMatchId', ownerMatchId)
            const localVarPath = `/api/owner-match-rules/{ownerMatchId}`
                .replace(`{${"ownerMatchId"}}`, encodeURIComponent(String(ownerMatchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} ownerMatchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOwnerMatchRulesOwnerMatchIdGet: async (ownerMatchId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ownerMatchId' is not null or undefined
            assertParamExists('apiOwnerMatchRulesOwnerMatchIdGet', 'ownerMatchId', ownerMatchId)
            const localVarPath = `/api/owner-match-rules/{ownerMatchId}`
                .replace(`{${"ownerMatchId"}}`, encodeURIComponent(String(ownerMatchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} ownerMatchId 
         * @param {UpdateOwnerMatchRuleInput} [updateOwnerMatchRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOwnerMatchRulesOwnerMatchIdPut: async (ownerMatchId: number, updateOwnerMatchRuleInput?: UpdateOwnerMatchRuleInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ownerMatchId' is not null or undefined
            assertParamExists('apiOwnerMatchRulesOwnerMatchIdPut', 'ownerMatchId', ownerMatchId)
            const localVarPath = `/api/owner-match-rules/{ownerMatchId}`
                .replace(`{${"ownerMatchId"}}`, encodeURIComponent(String(ownerMatchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOwnerMatchRuleInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateOwnerMatchRuleInput} [createOwnerMatchRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOwnerMatchRulesPost: async (createOwnerMatchRuleInput?: CreateOwnerMatchRuleInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/owner-match-rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOwnerMatchRuleInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsClassificationrulesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/scanreports/classificationrules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ClassificationRuleInput} [classificationRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsClassificationrulesPost: async (classificationRuleInput?: ClassificationRuleInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/scanreports/classificationrules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(classificationRuleInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsClassificationrulesRuleIdDelete: async (ruleId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('apiScanreportsClassificationrulesRuleIdDelete', 'ruleId', ruleId)
            const localVarPath = `/api/scanreports/classificationrules/{ruleId}`
                .replace(`{${"ruleId"}}`, encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {ClassificationRuleInput} [classificationRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsClassificationrulesRuleIdPut: async (ruleId: number, classificationRuleInput?: ClassificationRuleInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('apiScanreportsClassificationrulesRuleIdPut', 'ruleId', ruleId)
            const localVarPath = `/api/scanreports/classificationrules/{ruleId}`
                .replace(`{${"ruleId"}}`, encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(classificationRuleInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsClassificationrulesRuleIdRevertPut: async (ruleId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('apiScanreportsClassificationrulesRuleIdRevertPut', 'ruleId', ruleId)
            const localVarPath = `/api/scanreports/classificationrules/{ruleId}/revert`
                .replace(`{${"ruleId"}}`, encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ConfirmClassificationRuleSetInput} [confirmClassificationRuleSetInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsClassificationrulesRuleSetConfirmPut: async (confirmClassificationRuleSetInput?: ConfirmClassificationRuleSetInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/scanreports/classificationrules/rule-set/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(confirmClassificationRuleSetInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TrialRuleSetOptionDto} [trialRuleSetOptionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsClassificationrulesRuleSetTrialPost: async (trialRuleSetOptionDto?: TrialRuleSetOptionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/scanreports/classificationrules/rule-set/trial`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialRuleSetOptionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsClassificationrulesRuleSetTrialStatisGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/scanreports/classificationrules/rule-set/trial-statis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [clientId] 
         * @param {string} [machine] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsCountscannedfilesPost: async (clientId?: string, machine?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/scanreports/countscannedfiles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clientId !== undefined) {
                localVarQueryParameter['clientId'] = clientId;
            }

            if (machine !== undefined) {
                localVarQueryParameter['machine'] = machine;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FileRefsSearchInput} [fileRefsSearchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsFileRefsPost: async (fileRefsSearchInput?: FileRefsSearchInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/scanreports/file-refs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileRefsSearchInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsProtectionrulesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/scanreports/protectionrules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ProtectionRuleInput} [protectionRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsProtectionrulesPost: async (protectionRuleInput?: ProtectionRuleInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/scanreports/protectionrules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(protectionRuleInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsProtectionrulesRuleIdDelete: async (ruleId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('apiScanreportsProtectionrulesRuleIdDelete', 'ruleId', ruleId)
            const localVarPath = `/api/scanreports/protectionrules/{ruleId}`
                .replace(`{${"ruleId"}}`, encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {ProtectionRuleInput} [protectionRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsProtectionrulesRuleIdPut: async (ruleId: number, protectionRuleInput?: ProtectionRuleInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('apiScanreportsProtectionrulesRuleIdPut', 'ruleId', ruleId)
            const localVarPath = `/api/scanreports/protectionrules/{ruleId}`
                .replace(`{${"ruleId"}}`, encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(protectionRuleInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [clientId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsScanprogressGet: async (clientId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/scanreports/scanprogress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clientId !== undefined) {
                localVarQueryParameter['clientId'] = clientId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DmScanReportSummaryStatisQueryInput} [dmScanReportSummaryStatisQueryInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsStatisChartsPost: async (dmScanReportSummaryStatisQueryInput?: DmScanReportSummaryStatisQueryInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/scanreports/statis/charts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dmScanReportSummaryStatisQueryInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DmScanReportSummaryTableQueryInput} [dmScanReportSummaryTableQueryInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsStatisTablePost: async (dmScanReportSummaryTableQueryInput?: DmScanReportSummaryTableQueryInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/scanreports/statis/table`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dmScanReportSummaryTableQueryInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSettingsExcessiveDecryptGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings/excessive-decrypt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ExcessiveDecryptSettingInput} [excessiveDecryptSettingInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSettingsExcessiveDecryptPut: async (excessiveDecryptSettingInput?: ExcessiveDecryptSettingInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings/excessive-decrypt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(excessiveDecryptSettingInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SecureFilesApi - functional programming interface
 * @export
 */
export const SecureFilesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SecureFilesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCustomkeyvaultsDisablePost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCustomkeyvaultsDisablePost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CustomKeyVaultInput} [customKeyVaultInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCustomkeyvaultsEnablePost(customKeyVaultInput?: CustomKeyVaultInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCustomkeyvaultsEnablePost(customKeyVaultInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCustomkeyvaultsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomKeyVaultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCustomkeyvaultsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeBaseinfotypesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BaseInfoTypeResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeBaseinfotypesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeDocumenttemplatesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentTemplateResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeDocumenttemplatesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeDocumenttemplatesIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeDocumenttemplatesIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeDocumenttemplatesIdDownloadGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeDocumenttemplatesIdDownloadGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeDocumenttemplatesIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentTemplateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeDocumenttemplatesIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {DocumentTemplateInput} [documentTemplateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeDocumenttemplatesIdPut(id: string, documentTemplateInput?: DocumentTemplateInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeDocumenttemplatesIdPut(id, documentTemplateInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeDocumenttemplatesOcrresultIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OcrApiResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeDocumenttemplatesOcrresultIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DocumentTemplateInput} [documentTemplateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeDocumenttemplatesPost(documentTemplateInput?: DocumentTemplateInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentTemplateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeDocumenttemplatesPost(documentTemplateInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {any} [templateFile] 
         * @param {string} [id] 
         * @param {boolean} [isImage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeDocumenttemplatesUploadPost(templateFile?: any, id?: string, isImage?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExtractDocumentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeDocumenttemplatesUploadPost(templateFile, id, isImage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeInfotypesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InfoTypeResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeInfotypesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeInfotypesIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeInfotypesIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeInfotypesIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InfoTypeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeInfotypesIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {InfoTypeInput} [infoTypeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeInfotypesIdPut(id: string, infoTypeInput?: InfoTypeInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeInfotypesIdPut(id, infoTypeInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {InfoTypeInput} [infoTypeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeInfotypesPost(infoTypeInput?: InfoTypeInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InfoTypeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeInfotypesPost(infoTypeInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzePullPasswordPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContainerRegistryPullPasswordDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzePullPasswordPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeRepoAuthnInfoGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContainerRegistryPullPasswordDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeRepoAuthnInfoGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SearchInput} [searchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesAccessSearchPost(searchInput?: SearchInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileViewResponseDtoPaginationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesAccessSearchPost(searchInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SearchInput} [searchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesAccessUserOptionsPost(searchInput?: SearchInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesAccessUserOptionsPost(searchInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesAnalyzerIsconfiguredGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesAnalyzerIsconfiguredGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesAnalyzersettingDisableAnalyzerPut(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesAnalyzersettingDisableAnalyzerPut(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesAnalyzersettingGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataAnalyzerSettingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesAnalyzersettingGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DataAnalyzerSettingDto} [dataAnalyzerSettingDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesAnalyzersettingPost(dataAnalyzerSettingDto?: DataAnalyzerSettingDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesAnalyzersettingPost(dataAnalyzerSettingDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesAuditMachineOptionsPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesAuditMachineOptionsPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SearchInput} [searchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesAuditSearchPost(searchInput?: SearchInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileAuditResponseDtoPaginationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesAuditSearchPost(searchInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SearchInput} [searchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesAuditUserOptionsPost(searchInput?: SearchInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesAuditUserOptionsPost(searchInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {BulkUpdateFileInput} [bulkUpdateFileInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesBulkupdatePost(bulkUpdateFileInput?: BulkUpdateFileInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesBulkupdatePost(bulkUpdateFileInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [clientId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesClientsettingGet(clientId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientSettingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesClientsettingGet(clientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ClientSettingDto} [clientSettingDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesClientsettingPost(clientSettingDto?: ClientSettingDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesClientsettingPost(clientSettingDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesClientsettingQuerybyidsPost(requestBody?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientSettingDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesClientsettingQuerybyidsPost(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ClientSettingDto} [clientSettingDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesClientsettingRescanPost(clientSettingDto?: ClientSettingDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesClientsettingRescanPost(clientSettingDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {boolean} [forPlainFile] 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesDataOwnerGroupsQueryManyPost(forPlainFile?: boolean, requestBody?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataOwnerGroupByFileId>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesDataOwnerGroupsQueryManyPost(forPlainFile, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesExportPlainFileScanDownloadGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesExportPlainFileScanDownloadGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {FileCatalogSearchInput} [fileCatalogSearchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesExportPlainFileScanPost(fileCatalogSearchInput?: FileCatalogSearchInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesExportPlainFileScanPost(fileCatalogSearchInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesExportPlainFileScanWithInstanceDownloadGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesExportPlainFileScanWithInstanceDownloadGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {FileCatalogSearchInput} [fileCatalogSearchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesExportPlainFileScanWithInstancePost(fileCatalogSearchInput?: FileCatalogSearchInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesExportPlainFileScanWithInstancePost(fileCatalogSearchInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {FileCatalogSearchInput} [fileCatalogSearchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesExportPost(fileCatalogSearchInput?: FileCatalogSearchInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesExportPost(fileCatalogSearchInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {FileCatalogSearchInput} [fileCatalogSearchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesExportWithInstancePost(fileCatalogSearchInput?: FileCatalogSearchInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesExportWithInstancePost(fileCatalogSearchInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} fileId 
         * @param {boolean} [showDelete] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesFileIdGet(fileId: number, showDelete?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesFileIdGet(fileId, showDelete, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} fileId 
         * @param {boolean} [isPlainFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesFileIdInstancesCountGet(fileId: number, isPlainFile?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesFileIdInstancesCountGet(fileId, isPlainFile, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} fileId 
         * @param {number} [pageSize] 
         * @param {number} [pageIndex] 
         * @param {boolean} [showDelete] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesFileIdInstancesGet(fileId: number, pageSize?: number, pageIndex?: number, showDelete?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileInstanceResponseDtoPaginationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesFileIdInstancesGet(fileId, pageSize, pageIndex, showDelete, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} fileId 
         * @param {UpdateFileInput} [updateFileInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesFileIdPut(fileId: number, updateFileInput?: UpdateFileInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesFileIdPut(fileId, updateFileInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesGeneralsettingGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralSettingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesGeneralsettingGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GeneralSettingInput} [generalSettingInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesGeneralsettingPost(generalSettingInput?: GeneralSettingInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesGeneralsettingPost(generalSettingInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesLegalsettingGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LegalSettingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesLegalsettingGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {LegalSettingInput} [legalSettingInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesLegalsettingPost(legalSettingInput?: LegalSettingInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesLegalsettingPost(legalSettingInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {OfflineFileSearchInput} [offlineFileSearchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesOfflinefilesSearchPost(offlineFileSearchInput?: OfflineFileSearchInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfflineFileResponseDtoPaginationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesOfflinefilesSearchPost(offlineFileSearchInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {boolean} [forPlainFiles] 
         * @param {FileCatalogSearchInput} [fileCatalogSearchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesOwnershipStatisPost(forPlainFiles?: boolean, fileCatalogSearchInput?: FileCatalogSearchInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClassificationStatisticPointDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesOwnershipStatisPost(forPlainFiles, fileCatalogSearchInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {BulkUpdateFileInput} [bulkUpdateFileInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesPlainFileScansBulkupdatePost(bulkUpdateFileInput?: BulkUpdateFileInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesPlainFileScansBulkupdatePost(bulkUpdateFileInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} entryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesPlainFileScansEntryIdGet(entryId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlainFileScanResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesPlainFileScansEntryIdGet(entryId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} entryId 
         * @param {number} [pageSize] 
         * @param {number} [pageIndex] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesPlainFileScansEntryIdInstancesGet(entryId: number, pageSize?: number, pageIndex?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlainFileScanInstanceResponseDtoPaginationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesPlainFileScansEntryIdInstancesGet(entryId, pageSize, pageIndex, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} entryId 
         * @param {UpdateFileInput} [updateFileInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesPlainFileScansEntryIdPut(entryId: number, updateFileInput?: UpdateFileInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesPlainFileScansEntryIdPut(entryId, updateFileInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {FileCatalogSearchInput} [fileCatalogSearchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesSearchPlainFileScanPost(fileCatalogSearchInput?: FileCatalogSearchInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchFileCatalogResponseDto2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesSearchPlainFileScanPost(fileCatalogSearchInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {FileCatalogSearchInput} [fileCatalogSearchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesSearchPost(fileCatalogSearchInput?: FileCatalogSearchInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchFileCatalogResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesSearchPost(fileCatalogSearchInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesTagsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FileTagResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesTagsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AddFileTagInput} [addFileTagInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesTagsPost(addFileTagInput?: AddFileTagInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileTagResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesTagsPost(addFileTagInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOwnerMatchRulesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OwnerMatchRuleDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOwnerMatchRulesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {{ [key: string]: number; }} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOwnerMatchRulesMultipleReprioritizePost(requestBody?: { [key: string]: number; }, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOwnerMatchRulesMultipleReprioritizePost(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} ownerMatchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOwnerMatchRulesOwnerMatchIdDelete(ownerMatchId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOwnerMatchRulesOwnerMatchIdDelete(ownerMatchId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} ownerMatchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOwnerMatchRulesOwnerMatchIdGet(ownerMatchId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OwnerMatchRuleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOwnerMatchRulesOwnerMatchIdGet(ownerMatchId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} ownerMatchId 
         * @param {UpdateOwnerMatchRuleInput} [updateOwnerMatchRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOwnerMatchRulesOwnerMatchIdPut(ownerMatchId: number, updateOwnerMatchRuleInput?: UpdateOwnerMatchRuleInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOwnerMatchRulesOwnerMatchIdPut(ownerMatchId, updateOwnerMatchRuleInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateOwnerMatchRuleInput} [createOwnerMatchRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOwnerMatchRulesPost(createOwnerMatchRuleInput?: CreateOwnerMatchRuleInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OwnerMatchRuleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOwnerMatchRulesPost(createOwnerMatchRuleInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiScanreportsClassificationrulesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassificationRulesDisplayDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiScanreportsClassificationrulesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ClassificationRuleInput} [classificationRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiScanreportsClassificationrulesPost(classificationRuleInput?: ClassificationRuleInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiScanreportsClassificationrulesPost(classificationRuleInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiScanreportsClassificationrulesRuleIdDelete(ruleId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiScanreportsClassificationrulesRuleIdDelete(ruleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {ClassificationRuleInput} [classificationRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiScanreportsClassificationrulesRuleIdPut(ruleId: number, classificationRuleInput?: ClassificationRuleInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiScanreportsClassificationrulesRuleIdPut(ruleId, classificationRuleInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiScanreportsClassificationrulesRuleIdRevertPut(ruleId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiScanreportsClassificationrulesRuleIdRevertPut(ruleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ConfirmClassificationRuleSetInput} [confirmClassificationRuleSetInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiScanreportsClassificationrulesRuleSetConfirmPut(confirmClassificationRuleSetInput?: ConfirmClassificationRuleSetInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiScanreportsClassificationrulesRuleSetConfirmPut(confirmClassificationRuleSetInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {TrialRuleSetOptionDto} [trialRuleSetOptionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiScanreportsClassificationrulesRuleSetTrialPost(trialRuleSetOptionDto?: TrialRuleSetOptionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiScanreportsClassificationrulesRuleSetTrialPost(trialRuleSetOptionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiScanreportsClassificationrulesRuleSetTrialStatisGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrialResultStatisDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiScanreportsClassificationrulesRuleSetTrialStatisGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [clientId] 
         * @param {string} [machine] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiScanreportsCountscannedfilesPost(clientId?: string, machine?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiScanreportsCountscannedfilesPost(clientId, machine, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {FileRefsSearchInput} [fileRefsSearchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiScanreportsFileRefsPost(fileRefsSearchInput?: FileRefsSearchInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileRefDtoPaginationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiScanreportsFileRefsPost(fileRefsSearchInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiScanreportsProtectionrulesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProtectionRuleDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiScanreportsProtectionrulesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ProtectionRuleInput} [protectionRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiScanreportsProtectionrulesPost(protectionRuleInput?: ProtectionRuleInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiScanreportsProtectionrulesPost(protectionRuleInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiScanreportsProtectionrulesRuleIdDelete(ruleId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiScanreportsProtectionrulesRuleIdDelete(ruleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {ProtectionRuleInput} [protectionRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiScanreportsProtectionrulesRuleIdPut(ruleId: number, protectionRuleInput?: ProtectionRuleInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiScanreportsProtectionrulesRuleIdPut(ruleId, protectionRuleInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [clientId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiScanreportsScanprogressGet(clientId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScanJobProgressReportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiScanreportsScanprogressGet(clientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DmScanReportSummaryStatisQueryInput} [dmScanReportSummaryStatisQueryInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiScanreportsStatisChartsPost(dmScanReportSummaryStatisQueryInput?: DmScanReportSummaryStatisQueryInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DmScanReportSummaryStatisDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiScanreportsStatisChartsPost(dmScanReportSummaryStatisQueryInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DmScanReportSummaryTableQueryInput} [dmScanReportSummaryTableQueryInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiScanreportsStatisTablePost(dmScanReportSummaryTableQueryInput?: DmScanReportSummaryTableQueryInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DmScanReportSummaryDtoPaginationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiScanreportsStatisTablePost(dmScanReportSummaryTableQueryInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSettingsExcessiveDecryptGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExcessiveDecryptSettingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSettingsExcessiveDecryptGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ExcessiveDecryptSettingInput} [excessiveDecryptSettingInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSettingsExcessiveDecryptPut(excessiveDecryptSettingInput?: ExcessiveDecryptSettingInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSettingsExcessiveDecryptPut(excessiveDecryptSettingInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SecureFilesApi - factory interface
 * @export
 */
export const SecureFilesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SecureFilesApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomkeyvaultsDisablePost(options?: any): AxiosPromise<void> {
            return localVarFp.apiCustomkeyvaultsDisablePost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomKeyVaultInput} [customKeyVaultInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomkeyvaultsEnablePost(customKeyVaultInput?: CustomKeyVaultInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiCustomkeyvaultsEnablePost(customKeyVaultInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomkeyvaultsGet(options?: any): AxiosPromise<CustomKeyVaultDto> {
            return localVarFp.apiCustomkeyvaultsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeBaseinfotypesGet(options?: any): AxiosPromise<Array<BaseInfoTypeResponseDto>> {
            return localVarFp.apiDataanalyzeBaseinfotypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDocumenttemplatesGet(options?: any): AxiosPromise<Array<DocumentTemplateResponseDto>> {
            return localVarFp.apiDataanalyzeDocumenttemplatesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDocumenttemplatesIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiDataanalyzeDocumenttemplatesIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDocumenttemplatesIdDownloadGet(id: string, options?: any): AxiosPromise<string> {
            return localVarFp.apiDataanalyzeDocumenttemplatesIdDownloadGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDocumenttemplatesIdGet(id: string, options?: any): AxiosPromise<DocumentTemplateResponseDto> {
            return localVarFp.apiDataanalyzeDocumenttemplatesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {DocumentTemplateInput} [documentTemplateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDocumenttemplatesIdPut(id: string, documentTemplateInput?: DocumentTemplateInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiDataanalyzeDocumenttemplatesIdPut(id, documentTemplateInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDocumenttemplatesOcrresultIdGet(id: string, options?: any): AxiosPromise<OcrApiResultDto> {
            return localVarFp.apiDataanalyzeDocumenttemplatesOcrresultIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentTemplateInput} [documentTemplateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDocumenttemplatesPost(documentTemplateInput?: DocumentTemplateInput, options?: any): AxiosPromise<DocumentTemplateResponseDto> {
            return localVarFp.apiDataanalyzeDocumenttemplatesPost(documentTemplateInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {any} [templateFile] 
         * @param {string} [id] 
         * @param {boolean} [isImage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDocumenttemplatesUploadPost(templateFile?: any, id?: string, isImage?: boolean, options?: any): AxiosPromise<ExtractDocumentResponseDto> {
            return localVarFp.apiDataanalyzeDocumenttemplatesUploadPost(templateFile, id, isImage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeInfotypesGet(options?: any): AxiosPromise<Array<InfoTypeResponseDto>> {
            return localVarFp.apiDataanalyzeInfotypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeInfotypesIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiDataanalyzeInfotypesIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeInfotypesIdGet(id: string, options?: any): AxiosPromise<InfoTypeResponseDto> {
            return localVarFp.apiDataanalyzeInfotypesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {InfoTypeInput} [infoTypeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeInfotypesIdPut(id: string, infoTypeInput?: InfoTypeInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiDataanalyzeInfotypesIdPut(id, infoTypeInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InfoTypeInput} [infoTypeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeInfotypesPost(infoTypeInput?: InfoTypeInput, options?: any): AxiosPromise<InfoTypeResponseDto> {
            return localVarFp.apiDataanalyzeInfotypesPost(infoTypeInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzePullPasswordPost(options?: any): AxiosPromise<ContainerRegistryPullPasswordDto> {
            return localVarFp.apiDataanalyzePullPasswordPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeRepoAuthnInfoGet(options?: any): AxiosPromise<ContainerRegistryPullPasswordDto> {
            return localVarFp.apiDataanalyzeRepoAuthnInfoGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SearchInput} [searchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesAccessSearchPost(searchInput?: SearchInput, options?: any): AxiosPromise<FileViewResponseDtoPaginationResult> {
            return localVarFp.apiFilesAccessSearchPost(searchInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SearchInput} [searchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesAccessUserOptionsPost(searchInput?: SearchInput, options?: any): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.apiFilesAccessUserOptionsPost(searchInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesAnalyzerIsconfiguredGet(options?: any): AxiosPromise<boolean> {
            return localVarFp.apiFilesAnalyzerIsconfiguredGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesAnalyzersettingDisableAnalyzerPut(options?: any): AxiosPromise<void> {
            return localVarFp.apiFilesAnalyzersettingDisableAnalyzerPut(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesAnalyzersettingGet(options?: any): AxiosPromise<DataAnalyzerSettingDto> {
            return localVarFp.apiFilesAnalyzersettingGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DataAnalyzerSettingDto} [dataAnalyzerSettingDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesAnalyzersettingPost(dataAnalyzerSettingDto?: DataAnalyzerSettingDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiFilesAnalyzersettingPost(dataAnalyzerSettingDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesAuditMachineOptionsPost(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.apiFilesAuditMachineOptionsPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SearchInput} [searchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesAuditSearchPost(searchInput?: SearchInput, options?: any): AxiosPromise<FileAuditResponseDtoPaginationResult> {
            return localVarFp.apiFilesAuditSearchPost(searchInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SearchInput} [searchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesAuditUserOptionsPost(searchInput?: SearchInput, options?: any): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.apiFilesAuditUserOptionsPost(searchInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BulkUpdateFileInput} [bulkUpdateFileInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesBulkupdatePost(bulkUpdateFileInput?: BulkUpdateFileInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiFilesBulkupdatePost(bulkUpdateFileInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [clientId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesClientsettingGet(clientId?: string, options?: any): AxiosPromise<ClientSettingDto> {
            return localVarFp.apiFilesClientsettingGet(clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientSettingDto} [clientSettingDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesClientsettingPost(clientSettingDto?: ClientSettingDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiFilesClientsettingPost(clientSettingDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesClientsettingQuerybyidsPost(requestBody?: Array<string>, options?: any): AxiosPromise<Array<ClientSettingDto>> {
            return localVarFp.apiFilesClientsettingQuerybyidsPost(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientSettingDto} [clientSettingDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesClientsettingRescanPost(clientSettingDto?: ClientSettingDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiFilesClientsettingRescanPost(clientSettingDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} [forPlainFile] 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesDataOwnerGroupsQueryManyPost(forPlainFile?: boolean, requestBody?: Array<number>, options?: any): AxiosPromise<Array<DataOwnerGroupByFileId>> {
            return localVarFp.apiFilesDataOwnerGroupsQueryManyPost(forPlainFile, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesExportPlainFileScanDownloadGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiFilesExportPlainFileScanDownloadGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FileCatalogSearchInput} [fileCatalogSearchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesExportPlainFileScanPost(fileCatalogSearchInput?: FileCatalogSearchInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiFilesExportPlainFileScanPost(fileCatalogSearchInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesExportPlainFileScanWithInstanceDownloadGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiFilesExportPlainFileScanWithInstanceDownloadGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FileCatalogSearchInput} [fileCatalogSearchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesExportPlainFileScanWithInstancePost(fileCatalogSearchInput?: FileCatalogSearchInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiFilesExportPlainFileScanWithInstancePost(fileCatalogSearchInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FileCatalogSearchInput} [fileCatalogSearchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesExportPost(fileCatalogSearchInput?: FileCatalogSearchInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiFilesExportPost(fileCatalogSearchInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FileCatalogSearchInput} [fileCatalogSearchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesExportWithInstancePost(fileCatalogSearchInput?: FileCatalogSearchInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiFilesExportWithInstancePost(fileCatalogSearchInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} fileId 
         * @param {boolean} [showDelete] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesFileIdGet(fileId: number, showDelete?: boolean, options?: any): AxiosPromise<FileResponseDto> {
            return localVarFp.apiFilesFileIdGet(fileId, showDelete, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} fileId 
         * @param {boolean} [isPlainFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesFileIdInstancesCountGet(fileId: number, isPlainFile?: boolean, options?: any): AxiosPromise<number> {
            return localVarFp.apiFilesFileIdInstancesCountGet(fileId, isPlainFile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} fileId 
         * @param {number} [pageSize] 
         * @param {number} [pageIndex] 
         * @param {boolean} [showDelete] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesFileIdInstancesGet(fileId: number, pageSize?: number, pageIndex?: number, showDelete?: boolean, options?: any): AxiosPromise<FileInstanceResponseDtoPaginationResult> {
            return localVarFp.apiFilesFileIdInstancesGet(fileId, pageSize, pageIndex, showDelete, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} fileId 
         * @param {UpdateFileInput} [updateFileInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesFileIdPut(fileId: number, updateFileInput?: UpdateFileInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiFilesFileIdPut(fileId, updateFileInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesGeneralsettingGet(options?: any): AxiosPromise<GeneralSettingDto> {
            return localVarFp.apiFilesGeneralsettingGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralSettingInput} [generalSettingInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesGeneralsettingPost(generalSettingInput?: GeneralSettingInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiFilesGeneralsettingPost(generalSettingInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesLegalsettingGet(options?: any): AxiosPromise<LegalSettingDto> {
            return localVarFp.apiFilesLegalsettingGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LegalSettingInput} [legalSettingInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesLegalsettingPost(legalSettingInput?: LegalSettingInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiFilesLegalsettingPost(legalSettingInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OfflineFileSearchInput} [offlineFileSearchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesOfflinefilesSearchPost(offlineFileSearchInput?: OfflineFileSearchInput, options?: any): AxiosPromise<OfflineFileResponseDtoPaginationResult> {
            return localVarFp.apiFilesOfflinefilesSearchPost(offlineFileSearchInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} [forPlainFiles] 
         * @param {FileCatalogSearchInput} [fileCatalogSearchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesOwnershipStatisPost(forPlainFiles?: boolean, fileCatalogSearchInput?: FileCatalogSearchInput, options?: any): AxiosPromise<Array<ClassificationStatisticPointDto>> {
            return localVarFp.apiFilesOwnershipStatisPost(forPlainFiles, fileCatalogSearchInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BulkUpdateFileInput} [bulkUpdateFileInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesPlainFileScansBulkupdatePost(bulkUpdateFileInput?: BulkUpdateFileInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiFilesPlainFileScansBulkupdatePost(bulkUpdateFileInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} entryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesPlainFileScansEntryIdGet(entryId: number, options?: any): AxiosPromise<PlainFileScanResponseDto> {
            return localVarFp.apiFilesPlainFileScansEntryIdGet(entryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} entryId 
         * @param {number} [pageSize] 
         * @param {number} [pageIndex] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesPlainFileScansEntryIdInstancesGet(entryId: number, pageSize?: number, pageIndex?: number, options?: any): AxiosPromise<PlainFileScanInstanceResponseDtoPaginationResult> {
            return localVarFp.apiFilesPlainFileScansEntryIdInstancesGet(entryId, pageSize, pageIndex, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} entryId 
         * @param {UpdateFileInput} [updateFileInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesPlainFileScansEntryIdPut(entryId: number, updateFileInput?: UpdateFileInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiFilesPlainFileScansEntryIdPut(entryId, updateFileInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FileCatalogSearchInput} [fileCatalogSearchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesSearchPlainFileScanPost(fileCatalogSearchInput?: FileCatalogSearchInput, options?: any): AxiosPromise<SearchFileCatalogResponseDto2> {
            return localVarFp.apiFilesSearchPlainFileScanPost(fileCatalogSearchInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FileCatalogSearchInput} [fileCatalogSearchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesSearchPost(fileCatalogSearchInput?: FileCatalogSearchInput, options?: any): AxiosPromise<SearchFileCatalogResponseDto> {
            return localVarFp.apiFilesSearchPost(fileCatalogSearchInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesTagsGet(options?: any): AxiosPromise<Array<FileTagResponseDto>> {
            return localVarFp.apiFilesTagsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddFileTagInput} [addFileTagInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesTagsPost(addFileTagInput?: AddFileTagInput, options?: any): AxiosPromise<FileTagResponseDto> {
            return localVarFp.apiFilesTagsPost(addFileTagInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOwnerMatchRulesGet(options?: any): AxiosPromise<Array<OwnerMatchRuleDto>> {
            return localVarFp.apiOwnerMatchRulesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {{ [key: string]: number; }} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOwnerMatchRulesMultipleReprioritizePost(requestBody?: { [key: string]: number; }, options?: any): AxiosPromise<void> {
            return localVarFp.apiOwnerMatchRulesMultipleReprioritizePost(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} ownerMatchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOwnerMatchRulesOwnerMatchIdDelete(ownerMatchId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiOwnerMatchRulesOwnerMatchIdDelete(ownerMatchId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} ownerMatchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOwnerMatchRulesOwnerMatchIdGet(ownerMatchId: number, options?: any): AxiosPromise<OwnerMatchRuleDto> {
            return localVarFp.apiOwnerMatchRulesOwnerMatchIdGet(ownerMatchId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} ownerMatchId 
         * @param {UpdateOwnerMatchRuleInput} [updateOwnerMatchRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOwnerMatchRulesOwnerMatchIdPut(ownerMatchId: number, updateOwnerMatchRuleInput?: UpdateOwnerMatchRuleInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiOwnerMatchRulesOwnerMatchIdPut(ownerMatchId, updateOwnerMatchRuleInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateOwnerMatchRuleInput} [createOwnerMatchRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOwnerMatchRulesPost(createOwnerMatchRuleInput?: CreateOwnerMatchRuleInput, options?: any): AxiosPromise<OwnerMatchRuleDto> {
            return localVarFp.apiOwnerMatchRulesPost(createOwnerMatchRuleInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsClassificationrulesGet(options?: any): AxiosPromise<ClassificationRulesDisplayDto> {
            return localVarFp.apiScanreportsClassificationrulesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClassificationRuleInput} [classificationRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsClassificationrulesPost(classificationRuleInput?: ClassificationRuleInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiScanreportsClassificationrulesPost(classificationRuleInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsClassificationrulesRuleIdDelete(ruleId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiScanreportsClassificationrulesRuleIdDelete(ruleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {ClassificationRuleInput} [classificationRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsClassificationrulesRuleIdPut(ruleId: number, classificationRuleInput?: ClassificationRuleInput, options?: any): AxiosPromise<number> {
            return localVarFp.apiScanreportsClassificationrulesRuleIdPut(ruleId, classificationRuleInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsClassificationrulesRuleIdRevertPut(ruleId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiScanreportsClassificationrulesRuleIdRevertPut(ruleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ConfirmClassificationRuleSetInput} [confirmClassificationRuleSetInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsClassificationrulesRuleSetConfirmPut(confirmClassificationRuleSetInput?: ConfirmClassificationRuleSetInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiScanreportsClassificationrulesRuleSetConfirmPut(confirmClassificationRuleSetInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TrialRuleSetOptionDto} [trialRuleSetOptionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsClassificationrulesRuleSetTrialPost(trialRuleSetOptionDto?: TrialRuleSetOptionDto, options?: any): AxiosPromise<number> {
            return localVarFp.apiScanreportsClassificationrulesRuleSetTrialPost(trialRuleSetOptionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsClassificationrulesRuleSetTrialStatisGet(options?: any): AxiosPromise<TrialResultStatisDto> {
            return localVarFp.apiScanreportsClassificationrulesRuleSetTrialStatisGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [clientId] 
         * @param {string} [machine] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsCountscannedfilesPost(clientId?: string, machine?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiScanreportsCountscannedfilesPost(clientId, machine, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FileRefsSearchInput} [fileRefsSearchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsFileRefsPost(fileRefsSearchInput?: FileRefsSearchInput, options?: any): AxiosPromise<FileRefDtoPaginationResult> {
            return localVarFp.apiScanreportsFileRefsPost(fileRefsSearchInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsProtectionrulesGet(options?: any): AxiosPromise<Array<ProtectionRuleDto>> {
            return localVarFp.apiScanreportsProtectionrulesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProtectionRuleInput} [protectionRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsProtectionrulesPost(protectionRuleInput?: ProtectionRuleInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiScanreportsProtectionrulesPost(protectionRuleInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsProtectionrulesRuleIdDelete(ruleId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiScanreportsProtectionrulesRuleIdDelete(ruleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {ProtectionRuleInput} [protectionRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsProtectionrulesRuleIdPut(ruleId: number, protectionRuleInput?: ProtectionRuleInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiScanreportsProtectionrulesRuleIdPut(ruleId, protectionRuleInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [clientId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsScanprogressGet(clientId?: string, options?: any): AxiosPromise<ScanJobProgressReportDto> {
            return localVarFp.apiScanreportsScanprogressGet(clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DmScanReportSummaryStatisQueryInput} [dmScanReportSummaryStatisQueryInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsStatisChartsPost(dmScanReportSummaryStatisQueryInput?: DmScanReportSummaryStatisQueryInput, options?: any): AxiosPromise<DmScanReportSummaryStatisDto> {
            return localVarFp.apiScanreportsStatisChartsPost(dmScanReportSummaryStatisQueryInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DmScanReportSummaryTableQueryInput} [dmScanReportSummaryTableQueryInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsStatisTablePost(dmScanReportSummaryTableQueryInput?: DmScanReportSummaryTableQueryInput, options?: any): AxiosPromise<DmScanReportSummaryDtoPaginationResult> {
            return localVarFp.apiScanreportsStatisTablePost(dmScanReportSummaryTableQueryInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSettingsExcessiveDecryptGet(options?: any): AxiosPromise<ExcessiveDecryptSettingDto> {
            return localVarFp.apiSettingsExcessiveDecryptGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExcessiveDecryptSettingInput} [excessiveDecryptSettingInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSettingsExcessiveDecryptPut(excessiveDecryptSettingInput?: ExcessiveDecryptSettingInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiSettingsExcessiveDecryptPut(excessiveDecryptSettingInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SecureFilesApi - object-oriented interface
 * @export
 * @class SecureFilesApi
 * @extends {BaseAPI}
 */
export class SecureFilesApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiCustomkeyvaultsDisablePost(options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiCustomkeyvaultsDisablePost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomKeyVaultInput} [customKeyVaultInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiCustomkeyvaultsEnablePost(customKeyVaultInput?: CustomKeyVaultInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiCustomkeyvaultsEnablePost(customKeyVaultInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiCustomkeyvaultsGet(options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiCustomkeyvaultsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiDataanalyzeBaseinfotypesGet(options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiDataanalyzeBaseinfotypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiDataanalyzeDocumenttemplatesGet(options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiDataanalyzeDocumenttemplatesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiDataanalyzeDocumenttemplatesIdDelete(id: string, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiDataanalyzeDocumenttemplatesIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiDataanalyzeDocumenttemplatesIdDownloadGet(id: string, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiDataanalyzeDocumenttemplatesIdDownloadGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiDataanalyzeDocumenttemplatesIdGet(id: string, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiDataanalyzeDocumenttemplatesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {DocumentTemplateInput} [documentTemplateInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiDataanalyzeDocumenttemplatesIdPut(id: string, documentTemplateInput?: DocumentTemplateInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiDataanalyzeDocumenttemplatesIdPut(id, documentTemplateInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiDataanalyzeDocumenttemplatesOcrresultIdGet(id: string, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiDataanalyzeDocumenttemplatesOcrresultIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentTemplateInput} [documentTemplateInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiDataanalyzeDocumenttemplatesPost(documentTemplateInput?: DocumentTemplateInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiDataanalyzeDocumenttemplatesPost(documentTemplateInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {any} [templateFile] 
     * @param {string} [id] 
     * @param {boolean} [isImage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiDataanalyzeDocumenttemplatesUploadPost(templateFile?: any, id?: string, isImage?: boolean, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiDataanalyzeDocumenttemplatesUploadPost(templateFile, id, isImage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiDataanalyzeInfotypesGet(options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiDataanalyzeInfotypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiDataanalyzeInfotypesIdDelete(id: string, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiDataanalyzeInfotypesIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiDataanalyzeInfotypesIdGet(id: string, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiDataanalyzeInfotypesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {InfoTypeInput} [infoTypeInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiDataanalyzeInfotypesIdPut(id: string, infoTypeInput?: InfoTypeInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiDataanalyzeInfotypesIdPut(id, infoTypeInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InfoTypeInput} [infoTypeInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiDataanalyzeInfotypesPost(infoTypeInput?: InfoTypeInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiDataanalyzeInfotypesPost(infoTypeInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiDataanalyzePullPasswordPost(options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiDataanalyzePullPasswordPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiDataanalyzeRepoAuthnInfoGet(options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiDataanalyzeRepoAuthnInfoGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SearchInput} [searchInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesAccessSearchPost(searchInput?: SearchInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesAccessSearchPost(searchInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SearchInput} [searchInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesAccessUserOptionsPost(searchInput?: SearchInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesAccessUserOptionsPost(searchInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesAnalyzerIsconfiguredGet(options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesAnalyzerIsconfiguredGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesAnalyzersettingDisableAnalyzerPut(options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesAnalyzersettingDisableAnalyzerPut(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesAnalyzersettingGet(options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesAnalyzersettingGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DataAnalyzerSettingDto} [dataAnalyzerSettingDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesAnalyzersettingPost(dataAnalyzerSettingDto?: DataAnalyzerSettingDto, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesAnalyzersettingPost(dataAnalyzerSettingDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesAuditMachineOptionsPost(options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesAuditMachineOptionsPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SearchInput} [searchInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesAuditSearchPost(searchInput?: SearchInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesAuditSearchPost(searchInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SearchInput} [searchInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesAuditUserOptionsPost(searchInput?: SearchInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesAuditUserOptionsPost(searchInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BulkUpdateFileInput} [bulkUpdateFileInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesBulkupdatePost(bulkUpdateFileInput?: BulkUpdateFileInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesBulkupdatePost(bulkUpdateFileInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [clientId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesClientsettingGet(clientId?: string, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesClientsettingGet(clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientSettingDto} [clientSettingDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesClientsettingPost(clientSettingDto?: ClientSettingDto, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesClientsettingPost(clientSettingDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesClientsettingQuerybyidsPost(requestBody?: Array<string>, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesClientsettingQuerybyidsPost(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientSettingDto} [clientSettingDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesClientsettingRescanPost(clientSettingDto?: ClientSettingDto, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesClientsettingRescanPost(clientSettingDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} [forPlainFile] 
     * @param {Array<number>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesDataOwnerGroupsQueryManyPost(forPlainFile?: boolean, requestBody?: Array<number>, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesDataOwnerGroupsQueryManyPost(forPlainFile, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesExportPlainFileScanDownloadGet(options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesExportPlainFileScanDownloadGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FileCatalogSearchInput} [fileCatalogSearchInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesExportPlainFileScanPost(fileCatalogSearchInput?: FileCatalogSearchInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesExportPlainFileScanPost(fileCatalogSearchInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesExportPlainFileScanWithInstanceDownloadGet(options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesExportPlainFileScanWithInstanceDownloadGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FileCatalogSearchInput} [fileCatalogSearchInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesExportPlainFileScanWithInstancePost(fileCatalogSearchInput?: FileCatalogSearchInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesExportPlainFileScanWithInstancePost(fileCatalogSearchInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FileCatalogSearchInput} [fileCatalogSearchInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesExportPost(fileCatalogSearchInput?: FileCatalogSearchInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesExportPost(fileCatalogSearchInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FileCatalogSearchInput} [fileCatalogSearchInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesExportWithInstancePost(fileCatalogSearchInput?: FileCatalogSearchInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesExportWithInstancePost(fileCatalogSearchInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} fileId 
     * @param {boolean} [showDelete] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesFileIdGet(fileId: number, showDelete?: boolean, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesFileIdGet(fileId, showDelete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} fileId 
     * @param {boolean} [isPlainFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesFileIdInstancesCountGet(fileId: number, isPlainFile?: boolean, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesFileIdInstancesCountGet(fileId, isPlainFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} fileId 
     * @param {number} [pageSize] 
     * @param {number} [pageIndex] 
     * @param {boolean} [showDelete] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesFileIdInstancesGet(fileId: number, pageSize?: number, pageIndex?: number, showDelete?: boolean, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesFileIdInstancesGet(fileId, pageSize, pageIndex, showDelete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} fileId 
     * @param {UpdateFileInput} [updateFileInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesFileIdPut(fileId: number, updateFileInput?: UpdateFileInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesFileIdPut(fileId, updateFileInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesGeneralsettingGet(options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesGeneralsettingGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralSettingInput} [generalSettingInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesGeneralsettingPost(generalSettingInput?: GeneralSettingInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesGeneralsettingPost(generalSettingInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesLegalsettingGet(options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesLegalsettingGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LegalSettingInput} [legalSettingInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesLegalsettingPost(legalSettingInput?: LegalSettingInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesLegalsettingPost(legalSettingInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OfflineFileSearchInput} [offlineFileSearchInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesOfflinefilesSearchPost(offlineFileSearchInput?: OfflineFileSearchInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesOfflinefilesSearchPost(offlineFileSearchInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} [forPlainFiles] 
     * @param {FileCatalogSearchInput} [fileCatalogSearchInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesOwnershipStatisPost(forPlainFiles?: boolean, fileCatalogSearchInput?: FileCatalogSearchInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesOwnershipStatisPost(forPlainFiles, fileCatalogSearchInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BulkUpdateFileInput} [bulkUpdateFileInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesPlainFileScansBulkupdatePost(bulkUpdateFileInput?: BulkUpdateFileInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesPlainFileScansBulkupdatePost(bulkUpdateFileInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} entryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesPlainFileScansEntryIdGet(entryId: number, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesPlainFileScansEntryIdGet(entryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} entryId 
     * @param {number} [pageSize] 
     * @param {number} [pageIndex] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesPlainFileScansEntryIdInstancesGet(entryId: number, pageSize?: number, pageIndex?: number, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesPlainFileScansEntryIdInstancesGet(entryId, pageSize, pageIndex, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} entryId 
     * @param {UpdateFileInput} [updateFileInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesPlainFileScansEntryIdPut(entryId: number, updateFileInput?: UpdateFileInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesPlainFileScansEntryIdPut(entryId, updateFileInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FileCatalogSearchInput} [fileCatalogSearchInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesSearchPlainFileScanPost(fileCatalogSearchInput?: FileCatalogSearchInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesSearchPlainFileScanPost(fileCatalogSearchInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FileCatalogSearchInput} [fileCatalogSearchInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesSearchPost(fileCatalogSearchInput?: FileCatalogSearchInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesSearchPost(fileCatalogSearchInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesTagsGet(options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesTagsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AddFileTagInput} [addFileTagInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesTagsPost(addFileTagInput?: AddFileTagInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesTagsPost(addFileTagInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiOwnerMatchRulesGet(options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiOwnerMatchRulesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {{ [key: string]: number; }} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiOwnerMatchRulesMultipleReprioritizePost(requestBody?: { [key: string]: number; }, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiOwnerMatchRulesMultipleReprioritizePost(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} ownerMatchId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiOwnerMatchRulesOwnerMatchIdDelete(ownerMatchId: number, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiOwnerMatchRulesOwnerMatchIdDelete(ownerMatchId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} ownerMatchId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiOwnerMatchRulesOwnerMatchIdGet(ownerMatchId: number, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiOwnerMatchRulesOwnerMatchIdGet(ownerMatchId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} ownerMatchId 
     * @param {UpdateOwnerMatchRuleInput} [updateOwnerMatchRuleInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiOwnerMatchRulesOwnerMatchIdPut(ownerMatchId: number, updateOwnerMatchRuleInput?: UpdateOwnerMatchRuleInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiOwnerMatchRulesOwnerMatchIdPut(ownerMatchId, updateOwnerMatchRuleInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateOwnerMatchRuleInput} [createOwnerMatchRuleInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiOwnerMatchRulesPost(createOwnerMatchRuleInput?: CreateOwnerMatchRuleInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiOwnerMatchRulesPost(createOwnerMatchRuleInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiScanreportsClassificationrulesGet(options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiScanreportsClassificationrulesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClassificationRuleInput} [classificationRuleInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiScanreportsClassificationrulesPost(classificationRuleInput?: ClassificationRuleInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiScanreportsClassificationrulesPost(classificationRuleInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} ruleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiScanreportsClassificationrulesRuleIdDelete(ruleId: number, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiScanreportsClassificationrulesRuleIdDelete(ruleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} ruleId 
     * @param {ClassificationRuleInput} [classificationRuleInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiScanreportsClassificationrulesRuleIdPut(ruleId: number, classificationRuleInput?: ClassificationRuleInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiScanreportsClassificationrulesRuleIdPut(ruleId, classificationRuleInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} ruleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiScanreportsClassificationrulesRuleIdRevertPut(ruleId: number, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiScanreportsClassificationrulesRuleIdRevertPut(ruleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ConfirmClassificationRuleSetInput} [confirmClassificationRuleSetInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiScanreportsClassificationrulesRuleSetConfirmPut(confirmClassificationRuleSetInput?: ConfirmClassificationRuleSetInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiScanreportsClassificationrulesRuleSetConfirmPut(confirmClassificationRuleSetInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TrialRuleSetOptionDto} [trialRuleSetOptionDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiScanreportsClassificationrulesRuleSetTrialPost(trialRuleSetOptionDto?: TrialRuleSetOptionDto, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiScanreportsClassificationrulesRuleSetTrialPost(trialRuleSetOptionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiScanreportsClassificationrulesRuleSetTrialStatisGet(options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiScanreportsClassificationrulesRuleSetTrialStatisGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [clientId] 
     * @param {string} [machine] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiScanreportsCountscannedfilesPost(clientId?: string, machine?: string, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiScanreportsCountscannedfilesPost(clientId, machine, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FileRefsSearchInput} [fileRefsSearchInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiScanreportsFileRefsPost(fileRefsSearchInput?: FileRefsSearchInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiScanreportsFileRefsPost(fileRefsSearchInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiScanreportsProtectionrulesGet(options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiScanreportsProtectionrulesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProtectionRuleInput} [protectionRuleInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiScanreportsProtectionrulesPost(protectionRuleInput?: ProtectionRuleInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiScanreportsProtectionrulesPost(protectionRuleInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} ruleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiScanreportsProtectionrulesRuleIdDelete(ruleId: number, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiScanreportsProtectionrulesRuleIdDelete(ruleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} ruleId 
     * @param {ProtectionRuleInput} [protectionRuleInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiScanreportsProtectionrulesRuleIdPut(ruleId: number, protectionRuleInput?: ProtectionRuleInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiScanreportsProtectionrulesRuleIdPut(ruleId, protectionRuleInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [clientId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiScanreportsScanprogressGet(clientId?: string, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiScanreportsScanprogressGet(clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DmScanReportSummaryStatisQueryInput} [dmScanReportSummaryStatisQueryInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiScanreportsStatisChartsPost(dmScanReportSummaryStatisQueryInput?: DmScanReportSummaryStatisQueryInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiScanreportsStatisChartsPost(dmScanReportSummaryStatisQueryInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DmScanReportSummaryTableQueryInput} [dmScanReportSummaryTableQueryInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiScanreportsStatisTablePost(dmScanReportSummaryTableQueryInput?: DmScanReportSummaryTableQueryInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiScanreportsStatisTablePost(dmScanReportSummaryTableQueryInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiSettingsExcessiveDecryptGet(options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiSettingsExcessiveDecryptGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExcessiveDecryptSettingInput} [excessiveDecryptSettingInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiSettingsExcessiveDecryptPut(excessiveDecryptSettingInput?: ExcessiveDecryptSettingInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiSettingsExcessiveDecryptPut(excessiveDecryptSettingInput, options).then((request) => request(this.axios, this.basePath));
    }
}


